const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "501px",
    height: "498px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#94bbd6",
    d: "M 229.5,1.5 C 224.384,2.80629 219.051,3.47295 213.5,3.5C 218.598,2.04269 223.931,1.37603 229.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#77a5c5",
    d: "M 213.5,3.5 C 210.155,5.21697 206.489,5.88364 202.5,5.5C 205.909,4.09659 209.575,3.42993 213.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#17629e",
    d: "M 271.5,1.5 C 260.007,2.33066 248.341,2.83066 236.5,3C 228.652,4.59707 228.652,5.59707 236.5,6C 235.5,6.33333 234.5,6.66667 233.5,7C 236.482,7.49796 239.482,7.66463 242.5,7.5C 242.719,8.67504 242.386,9.67504 241.5,10.5C 239.775,11.0149 238.108,11.6816 236.5,12.5C 240.108,13.2543 243.775,13.7543 247.5,14C 245.899,14.2734 244.399,14.7734 243,15.5C 242.809,21.0829 242.309,26.5829 241.5,32C 242.91,32.3678 243.91,33.2011 244.5,34.5C 242.138,35.2715 239.804,36.1048 237.5,37C 240.833,37.6667 244.167,38.3333 247.5,39C 246.167,39.3333 244.833,39.6667 243.5,40C 252.95,40.1039 262.283,41.1039 271.5,43C 269.527,43.4955 267.527,43.6621 265.5,43.5C 259.974,43.8214 254.64,43.4881 249.5,42.5C 245.012,41.8341 240.346,41.5008 235.5,41.5C 227.615,41.3811 219.948,42.0478 212.5,43.5C 209.375,44.4794 206.042,44.8128 202.5,44.5C 197.566,44.2291 192.9,44.8958 188.5,46.5C 186.283,47.3686 183.95,47.702 181.5,47.5C 181.577,46.2502 182.244,45.4169 183.5,45C 187.764,44.5192 191.764,43.3526 195.5,41.5C 196.521,40.9984 196.688,40.3317 196,39.5C 194.933,38.8095 193.766,38.3095 192.5,38C 194.167,37.6667 195.833,37.3333 197.5,37C 196.328,36.5814 195.328,35.9147 194.5,35C 196.717,33.7246 199.051,32.7246 201.5,32C 200.552,31.5172 199.552,31.3505 198.5,31.5C 198.807,25.9066 198.473,20.4066 197.5,15C 198.167,14.6667 198.833,14.3333 199.5,14C 198.027,13.2904 197.36,12.1238 197.5,10.5C 192.786,10.3531 188.119,10.6864 183.5,11.5C 184.167,10.8333 184.833,10.1667 185.5,9.5C 187.905,8.2318 190.572,7.56513 193.5,7.5C 196.495,7.70621 199.162,7.03954 201.5,5.5C 201.833,5.5 202.167,5.5 202.5,5.5C 206.489,5.88364 210.155,5.21697 213.5,3.5C 219.051,3.47295 224.384,2.80629 229.5,1.5C 243.47,0.182231 257.47,0.182231 271.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.494
    },
    fill: "#97c4de",
    d: "M 287.5,4.5 C 287.5,4.16667 287.5,3.83333 287.5,3.5C 291.078,3.54877 294.411,4.21543 297.5,5.5C 294.14,5.38413 290.807,5.0508 287.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.686
    },
    fill: "#99bed7",
    d: "M 201.5,5.5 C 199.162,7.03954 196.495,7.70621 193.5,7.5C 195.905,6.2318 198.572,5.56513 201.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b68a9",
    d: "M 271.5,1.5 C 277.051,1.52705 282.384,2.19371 287.5,3.5C 287.5,3.83333 287.5,4.16667 287.5,4.5C 287.631,5.37644 287.298,6.04311 286.5,6.5C 281.521,5.21724 276.521,5.21724 271.5,6.5C 276.998,7.20783 282.331,8.54116 287.5,10.5C 285.172,11.724 282.839,11.724 280.5,10.5C 276.178,11.6915 275.845,13.0248 279.5,14.5C 278.2,21.4063 276.866,28.2396 275.5,35C 277.256,35.2022 278.922,35.7022 280.5,36.5C 277.5,37.1667 274.5,37.8333 271.5,38.5C 271.167,39.1667 270.833,39.8333 270.5,40.5C 274.078,42.303 277.745,43.6364 281.5,44.5C 279.167,44.5 276.833,44.5 274.5,44.5C 271.287,44.81 268.287,44.4767 265.5,43.5C 267.527,43.6621 269.527,43.4955 271.5,43C 262.283,41.1039 252.95,40.1039 243.5,40C 244.833,39.6667 246.167,39.3333 247.5,39C 244.167,38.3333 240.833,37.6667 237.5,37C 239.804,36.1048 242.138,35.2715 244.5,34.5C 243.91,33.2011 242.91,32.3678 241.5,32C 242.309,26.5829 242.809,21.0829 243,15.5C 244.399,14.7734 245.899,14.2734 247.5,14C 243.775,13.7543 240.108,13.2543 236.5,12.5C 238.108,11.6816 239.775,11.0149 241.5,10.5C 242.386,9.67504 242.719,8.67504 242.5,7.5C 239.482,7.66463 236.482,7.49796 233.5,7C 234.5,6.66667 235.5,6.33333 236.5,6C 228.652,5.59707 228.652,4.59707 236.5,3C 248.341,2.83066 260.007,2.33066 271.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.196
    },
    fill: "#aee1f3",
    d: "M 298.5,5.5 C 301.781,5.42032 304.781,6.08699 307.5,7.5C 304.219,7.57968 301.219,6.91301 298.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0670b1",
    d: "M 287.5,4.5 C 290.807,5.0508 294.14,5.38413 297.5,5.5C 297.833,5.5 298.167,5.5 298.5,5.5C 301.219,6.91301 304.219,7.57968 307.5,7.5C 309.292,7.36596 310.958,7.69929 312.5,8.5C 312.328,9.49162 312.662,10.1583 313.5,10.5C 315.476,12.0109 317.809,12.8442 320.5,13C 319.062,13.2189 317.729,13.7189 316.5,14.5C 319.436,15.3251 322.436,15.3251 325.5,14.5C 328.229,14.5047 330.229,15.6713 331.5,18C 329.307,19.0644 327.307,20.3977 325.5,22C 324.976,24.5588 325.642,27.0588 327.5,29.5C 325.644,35.2709 324.978,41.2709 325.5,47.5C 328.365,48.1316 330.698,49.6316 332.5,52C 329.69,52.7823 327.023,53.6156 324.5,54.5C 320.094,54.252 315.76,53.5853 311.5,52.5C 309.485,51.0762 307.152,50.4095 304.5,50.5C 304.167,50.5 303.833,50.5 303.5,50.5C 301.562,48.8372 299.228,48.1706 296.5,48.5C 292.779,48.0889 289.112,47.4222 285.5,46.5C 284.486,45.3263 283.153,44.6596 281.5,44.5C 277.745,43.6364 274.078,42.303 270.5,40.5C 270.833,39.8333 271.167,39.1667 271.5,38.5C 274.5,37.8333 277.5,37.1667 280.5,36.5C 278.922,35.7022 277.256,35.2022 275.5,35C 276.866,28.2396 278.2,21.4063 279.5,14.5C 275.845,13.0248 276.178,11.6915 280.5,10.5C 282.839,11.724 285.172,11.724 287.5,10.5C 282.331,8.54116 276.998,7.20783 271.5,6.5C 276.521,5.21724 281.521,5.21724 286.5,6.5C 287.298,6.04311 287.631,5.37644 287.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#7eb1ce",
    d: "M 312.5,8.5 C 314.786,8.59495 316.786,9.26162 318.5,10.5C 316.833,10.5 315.167,10.5 313.5,10.5C 312.662,10.1583 312.328,9.49162 312.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#98bad6",
    d: "M 185.5,9.5 C 184.833,10.1667 184.167,10.8333 183.5,11.5C 180.833,11.8333 178.167,12.1667 175.5,12.5C 178.55,10.8993 181.884,9.89934 185.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.416
    },
    fill: "#a8d2ea",
    d: "M 318.5,10.5 C 321.152,10.4095 323.485,11.0762 325.5,12.5C 322.848,12.5905 320.515,11.9238 318.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#035190",
    d: "M 181.5,47.5 C 176.523,47.5812 171.857,48.5812 167.5,50.5C 165.958,51.3007 164.292,51.634 162.5,51.5C 159.482,51.7038 156.482,52.0371 153.5,52.5C 149.702,52.823 146.369,54.1563 143.5,56.5C 143.167,56.5 142.833,56.5 142.5,56.5C 140.102,56.2594 138.102,56.9261 136.5,58.5C 136.167,58.5 135.833,58.5 135.5,58.5C 134.167,58.5 132.833,58.5 131.5,58.5C 129.833,58.5 128.167,58.5 126.5,58.5C 126.5,57.5 126.5,56.5 126.5,55.5C 127.75,55.5774 128.583,56.244 129,57.5C 129.308,56.6919 129.808,56.0253 130.5,55.5C 134.152,57.2849 137.152,56.6182 139.5,53.5C 138.624,52.7492 137.624,52.2492 136.5,52C 139.332,50.706 142.165,50.5393 145,51.5C 145.5,51.1667 146,50.8333 146.5,50.5C 144.754,48.1459 142.421,47.1459 139.5,47.5C 139.286,45.8561 139.62,44.3561 140.5,43C 137.574,39.8349 136.241,36.0015 136.5,31.5C 135.167,31.5 133.833,31.5 132.5,31.5C 132.5,31.1667 132.5,30.8333 132.5,30.5C 134.05,29.5592 135.716,28.8925 137.5,28.5C 139.967,28.2451 141.967,27.2451 143.5,25.5C 148.506,24.8285 152.839,22.8285 156.5,19.5C 160.228,19.2053 163.895,18.5386 167.5,17.5C 168.193,16.4822 168.859,15.4822 169.5,14.5C 171.898,14.7406 173.898,14.0739 175.5,12.5C 178.167,12.1667 180.833,11.8333 183.5,11.5C 188.119,10.6864 192.786,10.3531 197.5,10.5C 197.36,12.1238 198.027,13.2904 199.5,14C 198.833,14.3333 198.167,14.6667 197.5,15C 198.473,20.4066 198.807,25.9066 198.5,31.5C 199.552,31.3505 200.552,31.5172 201.5,32C 199.051,32.7246 196.717,33.7246 194.5,35C 195.328,35.9147 196.328,36.5814 197.5,37C 195.833,37.3333 194.167,37.6667 192.5,38C 193.766,38.3095 194.933,38.8095 196,39.5C 196.688,40.3317 196.521,40.9984 195.5,41.5C 191.764,43.3526 187.764,44.5192 183.5,45C 182.244,45.4169 181.577,46.2502 181.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.706
    },
    fill: "#94bcd9",
    d: "M 175.5,12.5 C 173.898,14.0739 171.898,14.7406 169.5,14.5C 171.214,13.2616 173.214,12.595 175.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.396
    },
    fill: "#95cde3",
    d: "M 331.5,14.5 C 334.542,14.7329 337.208,15.7329 339.5,17.5C 336.458,17.2671 333.792,16.2671 331.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d759d",
    d: "M 169.5,14.5 C 168.859,15.4822 168.193,16.4822 167.5,17.5C 163.895,18.5386 160.228,19.2053 156.5,19.5C 160.522,17.2661 164.856,15.5995 169.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#6286a9",
    d: "M 156.5,19.5 C 152.839,22.8285 148.506,24.8285 143.5,25.5C 147.416,22.7105 151.749,20.7105 156.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61a3c7",
    d: "M 339.5,17.5 C 352.315,21.5755 364.315,27.2422 375.5,34.5C 374.604,35.5063 373.938,35.5063 373.5,34.5C 364.46,29.57 354.96,25.2367 345,21.5C 343.18,20.0206 341.347,18.6873 339.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#88a7c3",
    d: "M 143.5,25.5 C 141.967,27.2451 139.967,28.2451 137.5,28.5C 139.033,26.7549 141.033,25.7549 143.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#047bbc",
    d: "M 313.5,10.5 C 315.167,10.5 316.833,10.5 318.5,10.5C 320.515,11.9238 322.848,12.5905 325.5,12.5C 327.786,12.595 329.786,13.2616 331.5,14.5C 333.792,16.2671 336.458,17.2671 339.5,17.5C 341.347,18.6873 343.18,20.0206 345,21.5C 354.96,25.2367 364.46,29.57 373.5,34.5C 370.361,35.1933 367.361,36.36 364.5,38C 366.305,38.972 367.972,40.1387 369.5,41.5C 367.441,42.9512 366.441,44.9512 366.5,47.5C 365.167,47.5 363.833,47.5 362.5,47.5C 362.211,53.5907 362.545,59.5907 363.5,65.5C 360.794,67.3707 357.96,69.0374 355,70.5C 352.572,69.0143 350.406,67.181 348.5,65C 345.522,64.304 342.522,63.804 339.5,63.5C 336.088,62.9251 333.088,61.5918 330.5,59.5C 328.204,58.1809 326.204,56.5143 324.5,54.5C 327.023,53.6156 329.69,52.7823 332.5,52C 330.698,49.6316 328.365,48.1316 325.5,47.5C 324.978,41.2709 325.644,35.2709 327.5,29.5C 325.642,27.0588 324.976,24.5588 325.5,22C 327.307,20.3977 329.307,19.0644 331.5,18C 330.229,15.6713 328.229,14.5047 325.5,14.5C 322.436,15.3251 319.436,15.3251 316.5,14.5C 317.729,13.7189 319.062,13.2189 320.5,13C 317.809,12.8442 315.476,12.0109 313.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.514
    },
    fill: "#b2cee3",
    d: "M 132.5,30.5 C 132.5,30.8333 132.5,31.1667 132.5,31.5C 131.833,31.5 131.5,31.8333 131.5,32.5C 130.833,32.5 130.167,32.5 129.5,32.5C 129.973,31.0937 130.973,30.427 132.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.631
    },
    fill: "#7ba0c0",
    d: "M 129.5,32.5 C 128.514,34.4077 126.848,35.4077 124.5,35.5C 125.659,33.7497 127.326,32.7497 129.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#014686",
    d: "M 132.5,31.5 C 133.833,31.5 135.167,31.5 136.5,31.5C 136.241,36.0015 137.574,39.8349 140.5,43C 139.62,44.3561 139.286,45.8561 139.5,47.5C 142.421,47.1459 144.754,48.1459 146.5,50.5C 146,50.8333 145.5,51.1667 145,51.5C 142.165,50.5393 139.332,50.706 136.5,52C 137.624,52.2492 138.624,52.7492 139.5,53.5C 137.152,56.6182 134.152,57.2849 130.5,55.5C 129.808,56.0253 129.308,56.6919 129,57.5C 128.583,56.244 127.75,55.5774 126.5,55.5C 121.051,55.9043 115.718,56.2377 110.5,56.5C 109.692,56.1924 109.025,55.6924 108.5,55C 111.693,53.3297 112.027,51.3297 109.5,49C 111.063,48.2186 113.063,47.2186 115.5,46C 116.416,40.1649 119.249,39.3316 124,43.5C 124.311,42.2575 123.811,41.2575 122.5,40.5C 125.376,39.8537 128.042,38.687 130.5,37C 131.38,35.6439 131.714,34.1439 131.5,32.5C 131.5,31.8333 131.833,31.5 132.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0182c6",
    d: "M 373.5,34.5 C 373.938,35.5063 374.604,35.5063 375.5,34.5C 375.833,34.5 376.167,34.5 376.5,34.5C 377.26,35.8933 377.926,37.3933 378.5,39C 377.755,40.5852 377.255,42.0852 377,43.5C 381.032,39.6154 384.866,39.9487 388.5,44.5C 386.195,44.6924 383.862,45.0257 381.5,45.5C 383.991,46.5407 383.991,47.3741 381.5,48C 383.823,52.8173 387.49,54.9839 392.5,54.5C 390.509,51.9084 388.176,49.7417 385.5,48C 387.365,46.6986 389.365,46.3653 391.5,47C 392.833,47.6667 392.833,48.3333 391.5,49C 397.624,51.1411 403.291,54.3078 408.5,58.5C 408.987,59.4461 409.32,60.4461 409.5,61.5C 407.781,72.7605 407.114,84.0939 407.5,95.5C 404.664,96.7755 401.664,97.4422 398.5,97.5C 397.025,98.8253 396.191,100.825 396,103.5C 395.333,102.833 394.667,102.167 394,101.5C 395.77,97.9603 397.603,94.2937 399.5,90.5C 395.789,84.8169 390.789,82.1502 384.5,82.5C 387.451,83.9526 389.951,85.9526 392,88.5C 393.345,90.8297 393.512,93.1631 392.5,95.5C 391.232,96.4279 389.899,96.5946 388.5,96C 389.38,94.6439 389.714,93.1439 389.5,91.5C 386.299,89.8226 382.965,88.3226 379.5,87C 379.167,86.6667 378.833,86.3333 378.5,86C 379.624,85.7508 380.624,85.2508 381.5,84.5C 380.147,83.3147 378.98,81.9814 378,80.5C 375.376,82.6989 372.542,83.0322 369.5,81.5C 369.632,77.2371 367.632,75.2371 363.5,75.5C 363.521,72.4652 364.854,70.1319 367.5,68.5C 366.412,67.0656 365.078,66.0656 363.5,65.5C 362.545,59.5907 362.211,53.5907 362.5,47.5C 363.833,47.5 365.167,47.5 366.5,47.5C 366.441,44.9512 367.441,42.9512 369.5,41.5C 367.972,40.1387 366.305,38.972 364.5,38C 367.361,36.36 370.361,35.1933 373.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.094
    },
    fill: "#a4cde2",
    d: "M 249.5,42.5 C 237.163,42.7335 224.83,43.0668 212.5,43.5C 219.948,42.0478 227.615,41.3811 235.5,41.5C 240.346,41.5008 245.012,41.8341 249.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#89b8d8",
    d: "M 274.5,44.5 C 276.833,44.5 279.167,44.5 281.5,44.5C 283.153,44.6596 284.486,45.3263 285.5,46.5C 281.613,46.3541 277.946,45.6874 274.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    fill: "#aed2e7",
    d: "M 202.5,44.5 C 198.057,45.8015 193.391,46.4681 188.5,46.5C 192.9,44.8958 197.566,44.2291 202.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#9cafca",
    d: "M 106.5,46.5 C 105.738,48.2624 104.404,49.2624 102.5,49.5C 103.262,47.7376 104.596,46.7376 106.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.173
    },
    fill: "#b2d2e8",
    d: "M 181.5,47.5 C 177.079,49.1015 172.412,50.1015 167.5,50.5C 171.857,48.5812 176.523,47.5812 181.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.851
    },
    fill: "#8ec3e1",
    d: "M 296.5,48.5 C 299.228,48.1706 301.562,48.8372 303.5,50.5C 300.933,50.2785 298.599,49.6118 296.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.69
    },
    fill: "#88a7c4",
    d: "M 102.5,49.5 C 102.027,50.9063 101.027,51.573 99.5,51.5C 99.9731,50.0937 100.973,49.427 102.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.722
    },
    fill: "#93cce5",
    d: "M 304.5,50.5 C 307.152,50.4095 309.485,51.0762 311.5,52.5C 308.848,52.5905 306.515,51.9238 304.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.576
    },
    fill: "#96adc5",
    d: "M 99.5,51.5 C 98.7377,53.2624 97.4044,54.2624 95.5,54.5C 96.2623,52.7376 97.5956,51.7376 99.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#688baf",
    d: "M 153.5,52.5 C 153.5,52.8333 153.5,53.1667 153.5,53.5C 150.381,54.8699 147.048,55.8699 143.5,56.5C 146.369,54.1563 149.702,52.823 153.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.078
    },
    fill: "#bdd4e8",
    d: "M 162.5,51.5 C 159.781,52.913 156.781,53.5797 153.5,53.5C 153.5,53.1667 153.5,52.8333 153.5,52.5C 156.482,52.0371 159.482,51.7038 162.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#beecf4",
    d: "M 401.5,51.5 C 403.027,51.427 404.027,52.0937 404.5,53.5C 402.973,53.573 401.973,52.9063 401.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#12427d",
    d: "M 129.5,32.5 C 130.167,32.5 130.833,32.5 131.5,32.5C 131.714,34.1439 131.38,35.6439 130.5,37C 128.042,38.687 125.376,39.8537 122.5,40.5C 123.811,41.2575 124.311,42.2575 124,43.5C 119.249,39.3316 116.416,40.1649 115.5,46C 113.063,47.2186 111.063,48.2186 109.5,49C 112.027,51.3297 111.693,53.3297 108.5,55C 109.025,55.6924 109.692,56.1924 110.5,56.5C 115.718,56.2377 121.051,55.9043 126.5,55.5C 126.5,56.5 126.5,57.5 126.5,58.5C 123.117,60.2748 119.45,61.6082 115.5,62.5C 114.558,62.3918 113.725,62.0585 113,61.5C 109.342,64.0657 105.842,66.7324 102.5,69.5C 101.07,70.5375 99.403,71.2041 97.5,71.5C 95.4471,71.4021 93.7804,72.0687 92.5,73.5C 91.209,73.2627 90.209,73.596 89.5,74.5C 87.4907,76.0652 85.1573,77.0652 82.5,77.5C 79.7594,77.7073 77.4261,78.7073 75.5,80.5C 75.5,80.8333 75.5,81.1667 75.5,81.5C 72.8333,82.5 70.1667,83.5 67.5,84.5C 66.5084,84.3284 65.8417,84.6618 65.5,85.5C 64.1266,85.6567 62.7932,85.49 61.5,85C 64.7044,81.9641 67.7044,78.7974 70.5,75.5C 71.1667,74.1667 72.1667,73.1667 73.5,72.5C 76.4274,71.2427 78.7607,69.2427 80.5,66.5C 83.0892,65.5806 85.0892,63.914 86.5,61.5C 90.3633,60.3064 93.3633,57.973 95.5,54.5C 97.4044,54.2624 98.7377,53.2624 99.5,51.5C 101.027,51.573 102.027,50.9063 102.5,49.5C 104.404,49.2624 105.738,48.2624 106.5,46.5C 111.824,41.8327 117.824,38.166 124.5,35.5C 126.848,35.4077 128.514,34.4077 129.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#60a1c7",
    d: "M 311.5,52.5 C 315.76,53.5853 320.094,54.252 324.5,54.5C 326.204,56.5143 328.204,58.1809 330.5,59.5C 323.861,57.7343 317.527,55.401 311.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 91.5,56.5 C 90.8333,55.1667 90.8333,55.1667 91.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#6e8aa8",
    d: "M 95.5,54.5 C 93.3633,57.973 90.3633,60.3064 86.5,61.5C 87.5045,60.3172 88.3378,58.9839 89,57.5C 90.159,58.566 90.9924,58.2327 91.5,56.5C 92.6049,55.3995 93.9382,54.7329 95.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.149
    },
    fill: "#c4d7e9",
    d: "M 142.5,56.5 C 140.786,57.7384 138.786,58.405 136.5,58.5C 138.102,56.9261 140.102,56.2594 142.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#c1d7e8",
    d: "M 131.5,58.5 C 132.833,58.5 134.167,58.5 135.5,58.5C 133.485,59.9238 131.152,60.5905 128.5,60.5C 129.5,59.8333 130.5,59.1667 131.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#40608d",
    d: "M 126.5,58.5 C 128.167,58.5 129.833,58.5 131.5,58.5C 130.5,59.1667 129.5,59.8333 128.5,60.5C 127.5,61.1667 126.5,61.8333 125.5,62.5C 122.539,63.3234 119.539,63.99 116.5,64.5C 114.214,64.595 112.214,65.2616 110.5,66.5C 108.11,68.0198 105.443,69.0198 102.5,69.5C 105.842,66.7324 109.342,64.0657 113,61.5C 113.725,62.0585 114.558,62.3918 115.5,62.5C 119.45,61.6082 123.117,60.2748 126.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#188bc9",
    d: "M 376.5,34.5 C 385.39,39.4376 393.723,45.1042 401.5,51.5C 401.973,52.9063 402.973,53.573 404.5,53.5C 413.117,59.45 420.784,66.45 427.5,74.5C 424.813,73.6644 422.48,72.1644 420.5,70C 418.365,69.3653 416.365,69.6986 414.5,71C 415.376,72.5848 416.709,73.5848 418.5,74C 417.304,75.8335 416.471,77.6669 416,79.5C 417.299,79.9662 418.799,79.9662 420.5,79.5C 420.667,90.1719 420.5,100.839 420,111.5C 419.782,114.426 419.282,117.26 418.5,120C 422.067,121.707 422.234,123.541 419,125.5C 418.71,123.956 418.044,122.623 417,121.5C 416.505,123.473 416.338,125.473 416.5,127.5C 415.779,124.456 413.779,122.789 410.5,122.5C 398.473,107.14 384.806,93.4729 369.5,81.5C 372.542,83.0322 375.376,82.6989 378,80.5C 378.98,81.9814 380.147,83.3147 381.5,84.5C 380.624,85.2508 379.624,85.7508 378.5,86C 378.833,86.3333 379.167,86.6667 379.5,87C 382.965,88.3226 386.299,89.8226 389.5,91.5C 389.714,93.1439 389.38,94.6439 388.5,96C 389.899,96.5946 391.232,96.4279 392.5,95.5C 393.512,93.1631 393.345,90.8297 392,88.5C 389.951,85.9526 387.451,83.9526 384.5,82.5C 390.789,82.1502 395.789,84.8169 399.5,90.5C 397.603,94.2937 395.77,97.9603 394,101.5C 394.667,102.167 395.333,102.833 396,103.5C 396.191,100.825 397.025,98.8253 398.5,97.5C 401.664,97.4422 404.664,96.7755 407.5,95.5C 407.114,84.0939 407.781,72.7605 409.5,61.5C 409.32,60.4461 408.987,59.4461 408.5,58.5C 403.291,54.3078 397.624,51.1411 391.5,49C 392.833,48.3333 392.833,47.6667 391.5,47C 389.365,46.3653 387.365,46.6986 385.5,48C 388.176,49.7417 390.509,51.9084 392.5,54.5C 387.49,54.9839 383.823,52.8173 381.5,48C 383.991,47.3741 383.991,46.5407 381.5,45.5C 383.862,45.0257 386.195,44.6924 388.5,44.5C 384.866,39.9487 381.032,39.6154 377,43.5C 377.255,42.0852 377.755,40.5852 378.5,39C 377.926,37.3933 377.26,35.8933 376.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 125.5,62.5 C 126.833,63.1667 126.833,63.1667 125.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.769
    },
    fill: "#7e95b0",
    d: "M 86.5,61.5 C 85.0892,63.914 83.0892,65.5806 80.5,66.5C 81.9108,64.086 83.9108,62.4194 86.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#c6daec",
    d: "M 116.5,64.5 C 114.898,66.0739 112.898,66.7406 110.5,66.5C 112.214,65.2616 114.214,64.595 116.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#398dc0",
    d: "M 339.5,63.5 C 342.522,63.804 345.522,64.304 348.5,65C 350.406,67.181 352.572,69.0143 355,70.5C 357.96,69.0374 360.794,67.3707 363.5,65.5C 365.078,66.0656 366.412,67.0656 367.5,68.5C 364.854,70.1319 363.521,72.4652 363.5,75.5C 367.632,75.2371 369.632,77.2371 369.5,81.5C 359.492,75.4967 349.492,69.4967 339.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.753
    },
    fill: "#7b95b2",
    d: "M 80.5,66.5 C 78.7607,69.2427 76.4274,71.2427 73.5,72.5C 75.2393,69.7573 77.5726,67.7573 80.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.102
    },
    fill: "#bed1df",
    d: "M 97.5,71.5 C 97.5,71.8333 97.5,72.1667 97.5,72.5C 95.8828,73.038 94.2161,73.3713 92.5,73.5C 93.7804,72.0687 95.4471,71.4021 97.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 97.5,72.5 C 98.8333,73.1667 98.8333,73.1667 97.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#dae3ed",
    d: "M 89.5,74.5 C 90.209,73.596 91.209,73.2627 92.5,73.5C 92.631,74.2389 92.4643,74.9056 92,75.5C 91.3292,74.7476 90.4959,74.4142 89.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.294
    },
    fill: "#a6bdd4",
    d: "M 82.5,77.5 C 80.5739,79.2927 78.2406,80.2927 75.5,80.5C 77.4261,78.7073 79.7594,77.7073 82.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 75.5,81.5 C 76.8333,82.1667 76.8333,82.1667 75.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.011
    },
    fill: "#f2f4fa",
    d: "M 65.5,85.5 C 65.8417,84.6618 66.5084,84.3284 67.5,84.5C 67.7148,86.1788 67.0481,87.1788 65.5,87.5C 65.5,87.1667 65.5,86.8333 65.5,86.5C 66.8333,86.1667 66.8333,85.8333 65.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b89a2",
    d: "M 70.5,75.5 C 67.7044,78.7974 64.7044,81.9641 61.5,85C 62.7932,85.49 64.1266,85.6567 65.5,85.5C 65.5,85.8333 65.5,86.1667 65.5,86.5C 62.911,86.461 60.911,87.461 59.5,89.5C 58.8333,89.5 58.1667,89.5 57.5,89.5C 56.8333,89.5 56.5,89.1667 56.5,88.5C 60.5593,83.438 65.226,79.1047 70.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 63.5,88.5 C 63.8417,87.6618 64.5084,87.3284 65.5,87.5C 65.1583,88.3382 64.4916,88.6716 63.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 63.5,88.5 C 62.8333,89.1667 62.8333,89.1667 63.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#fefffe",
    d: "M 59.5,89.5 C 60.7733,90.0768 60.7733,90.7435 59.5,91.5C 58.537,91.0302 58.537,90.3635 59.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 62.5,89.5 C 61.8333,90.1667 61.8333,90.1667 62.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#f2f5f7",
    d: "M 56.5,88.5 C 56.5,89.1667 56.8333,89.5 57.5,89.5C 57.6716,90.4916 57.3382,91.1583 56.5,91.5C 55.375,90.3478 55.375,89.3478 56.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 56.5,91.5 C 55.8333,92.1667 55.8333,92.1667 56.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eafd5",
    d: "M 451.5,102.5 C 453.9,104.296 455.567,106.63 456.5,109.5C 452.88,108.548 451.213,106.215 451.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0691d4",
    d: "M 427.5,74.5 C 433.829,79.9962 439.663,85.9962 445,92.5C 447.437,95.7196 449.603,99.053 451.5,102.5C 451.213,106.215 452.88,108.548 456.5,109.5C 456.34,111.199 456.506,112.866 457,114.5C 459.594,116.704 461.428,119.37 462.5,122.5C 461.175,121.047 460.342,121.381 460,123.5C 458.815,121.441 457.648,121.274 456.5,123C 457.682,124.679 459.015,126.179 460.5,127.5C 461.278,122.683 462.945,122.517 465.5,127C 464.853,128.609 464.02,130.109 463,131.5C 462.667,130.5 462.333,129.5 462,128.5C 461.454,131.855 461.621,135.188 462.5,138.5C 462.61,140.374 461.944,141.874 460.5,143C 461.498,212.429 461.831,281.929 461.5,351.5C 466.149,352.295 470.816,352.461 475.5,352C 474.483,350.951 474.316,349.784 475,348.5C 476.751,347.778 478.251,346.778 479.5,345.5C 479.5,347.167 479.5,348.833 479.5,350.5C 477.121,349.433 476.121,350.433 476.5,353.5C 458.833,353.5 441.167,353.5 423.5,353.5C 420.038,352.518 416.371,352.185 412.5,352.5C 411.122,351.766 409.622,351.099 408,350.5C 407.5,340.172 407.334,329.839 407.5,319.5C 400.833,319.167 400.833,318.833 407.5,318.5C 407.5,317.5 407.5,316.5 407.5,315.5C 412.049,314.925 415.882,316.258 419,319.5C 420.438,318.1 421.271,316.433 421.5,314.5C 423.099,314.768 424.432,314.434 425.5,313.5C 425.5,312.833 425.5,312.167 425.5,311.5C 427.293,309.574 428.293,307.241 428.5,304.5C 428.5,304.167 428.5,303.833 428.5,303.5C 430.897,300.691 432.23,297.358 432.5,293.5C 432.5,293.167 432.5,292.833 432.5,292.5C 434.472,289.916 435.472,286.916 435.5,283.5C 436.768,281.095 437.435,278.428 437.5,275.5C 437.366,273.708 437.699,272.042 438.5,270.5C 439.913,267.781 440.58,264.781 440.5,261.5C 441.556,253.032 442.556,244.699 443.5,236.5C 444.166,232.18 444.499,227.68 444.5,223C 444.636,215.609 443.969,208.443 442.5,201.5C 442.5,200.833 442.5,200.167 442.5,199.5C 441.994,193.464 441.161,187.464 440,181.5C 439.617,180.944 439.117,180.611 438.5,180.5C 438.5,180.167 438.5,179.833 438.5,179.5C 438.59,176.848 437.924,174.515 436.5,172.5C 435.265,169.67 434.265,166.67 433.5,163.5C 433.585,160.351 432.585,157.684 430.5,155.5C 428.935,153.491 427.935,151.157 427.5,148.5C 427.121,144.985 426.121,141.652 424.5,138.5C 421.082,135.31 418.415,131.644 416.5,127.5C 416.338,125.473 416.505,123.473 417,121.5C 418.044,122.623 418.71,123.956 419,125.5C 422.234,123.541 422.067,121.707 418.5,120C 419.282,117.26 419.782,114.426 420,111.5C 420.5,100.839 420.667,90.1719 420.5,79.5C 418.799,79.9662 417.299,79.9662 416,79.5C 416.471,77.6669 417.304,75.8335 418.5,74C 416.709,73.5848 415.376,72.5848 414.5,71C 416.365,69.6986 418.365,69.3653 420.5,70C 422.48,72.1644 424.813,73.6644 427.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#64b4d2",
    d: "M 456.5,109.5 C 459.952,113.299 462.618,117.632 464.5,122.5C 463.833,122.5 463.167,122.5 462.5,122.5C 461.428,119.37 459.594,116.704 457,114.5C 456.506,112.866 456.34,111.199 456.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#63aed0",
    d: "M 410.5,122.5 C 413.779,122.789 415.779,124.456 416.5,127.5C 418.415,131.644 421.082,135.31 424.5,138.5C 426.121,141.652 427.121,144.985 427.5,148.5C 422.654,139.316 416.987,130.649 410.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 238.5,142.5 C 239.833,143.167 239.833,143.167 238.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 236.5,144.5 C 237.833,145.167 237.833,145.167 236.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.489
    },
    fill: "#9c9c9e",
    d: "M 293.5,151.5 C 293.5,149.5 293.5,147.5 293.5,145.5C 288.833,145.5 284.167,145.5 279.5,145.5C 265.754,145.185 252.088,145.519 238.5,146.5C 258.048,144.828 277.881,143.828 298,143.5C 297.313,146.532 295.813,149.199 293.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b1b19",
    d: "M 78.5,145.5 C 78.5569,146.609 78.8902,147.609 79.5,148.5C 79.5654,148.938 79.3988,149.272 79,149.5C 78,148.5 77,147.5 76,146.5C 74.4702,147.636 73.1369,148.636 72,149.5C 71.6121,148.572 70.9454,147.905 70,147.5C 68.51,148.317 67.01,149.15 65.5,150C 65.8333,150.333 66.1667,150.667 66.5,151C 65.7819,153.461 65.1153,155.961 64.5,158.5C 68.374,160.002 68.0407,160.669 63.5,160.5C 63.5,162.833 63.5,165.167 63.5,167.5C 61.8333,167.5 60.1667,167.5 58.5,167.5C 58.2601,170.579 58.5934,173.579 59.5,176.5C 55.0268,180.455 53.0268,185.455 53.5,191.5C 52.5,191.5 51.5,191.5 50.5,191.5C 50.5,194.167 50.5,196.833 50.5,199.5C 49.5,199.5 48.5,199.5 47.5,199.5C 47.6641,196.813 47.4974,194.146 47,191.5C 46.9994,194.687 46.1661,197.52 44.5,200C 46.988,204.364 46.8213,208.53 44,212.5C 43.3333,211.833 42.6667,211.167 42,210.5C 41.9159,214.781 41.2493,219.115 40,223.5C 37.8003,225.615 35.8003,227.949 34,230.5C 33.6499,235.184 33.1499,239.851 32.5,244.5C 33.3329,246.5 33.1662,248.166 32,249.5C 31.6667,247.833 31.3333,246.167 31,244.5C 30.8173,247.931 29.6506,251.264 27.5,254.5C 26.3717,255.262 25.2051,255.929 24,256.5C 22.2398,261.225 21.4065,266.225 21.5,271.5C 20.1667,271.5 18.8333,271.5 17.5,271.5C 15.4868,277.842 13.9868,284.509 13,291.5C 12.3333,294.167 11.6667,294.167 11,291.5C 9.19307,295.431 8.0264,299.431 7.5,303.5C 7.01131,302.005 6.34464,300.671 5.5,299.5C 4.65859,297.621 4.32526,295.621 4.5,293.5C 4.31041,288.63 3.64374,283.964 2.5,279.5C -0.797671,252.804 0.202329,226.138 5.5,199.5C 7.03954,197.162 7.70621,194.495 7.5,191.5C 7.89839,187.239 8.89839,183.239 10.5,179.5C 12.0739,177.898 12.7406,175.898 12.5,173.5C 12.2322,171.901 12.5655,170.568 13.5,169.5C 15.0739,167.898 15.7406,165.898 15.5,163.5C 15.2322,161.901 15.5655,160.568 16.5,159.5C 18.5848,157.316 19.5848,154.649 19.5,151.5C 19.2627,150.209 19.596,149.209 20.5,148.5C 21.9063,148.027 22.573,147.027 22.5,145.5C 41.1667,144.167 59.8333,144.167 78.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424243",
    d: "M 279.5,145.5 C 276.858,146.102 274.525,147.436 272.5,149.5C 270.464,147.655 268.13,147.155 265.5,148C 266.974,149.316 268.641,150.316 270.5,151C 269.207,151.49 267.873,151.657 266.5,151.5C 266.157,155.526 264.157,158.526 260.5,160.5C 263.093,162.071 264.093,164.404 263.5,167.5C 262.5,167.5 261.5,167.5 260.5,167.5C 258.192,172.566 256.692,177.9 256,183.5C 255.667,182.167 255.333,180.833 255,179.5C 253.199,181.138 253.032,182.972 254.5,185C 253.782,188.461 253.282,191.961 253,195.5C 251.956,194.377 251.29,193.044 251,191.5C 249.294,194.959 249.128,198.459 250.5,202C 247.228,202.437 245.561,204.27 245.5,207.5C 244.448,207.351 243.448,207.517 242.5,208C 244.134,208.494 245.801,208.66 247.5,208.5C 247.351,207.448 247.517,206.448 248,205.5C 249.848,207.018 251.348,208.851 252.5,211C 250.578,212.233 248.411,212.4 246,211.5C 243.333,211.167 241.333,212.167 240,214.5C 239.257,212.355 238.424,212.189 237.5,214C 238.952,215.565 240.619,216.898 242.5,218C 241.167,219 241.167,220 242.5,221C 240.754,223.259 238.42,224.592 235.5,225C 237.158,225.725 237.658,226.892 237,228.5C 235.413,227.273 234.079,227.606 233,229.5C 232.043,232.379 232.543,234.879 234.5,237C 233.833,237.333 233.167,237.667 232.5,238C 233.252,238.671 233.586,239.504 233.5,240.5C 231.554,244.439 229.221,248.106 226.5,251.5C 225.504,251.586 224.671,251.252 224,250.5C 223.506,252.134 223.34,253.801 223.5,255.5C 222.094,255.973 221.427,256.973 221.5,258.5C 218.898,264.053 215.564,269.053 211.5,273.5C 210.094,273.973 209.427,274.973 209.5,276.5C 206.833,280.833 204.167,285.167 201.5,289.5C 199.408,292.681 197.075,295.681 194.5,298.5C 193.599,299.29 192.932,300.29 192.5,301.5C 191.005,301.989 189.671,302.655 188.5,303.5C 188.565,303.938 188.399,304.272 188,304.5C 187.25,303.874 186.416,303.374 185.5,303C 187.689,302.323 188.022,301.156 186.5,299.5C 187.631,298.396 188.465,298.729 189,300.5C 192.361,296.659 195.194,293.159 197.5,290C 197.167,289.167 196.833,288.333 196.5,287.5C 196.704,288.529 196.204,289.529 195,290.5C 192.872,287.176 192.039,283.509 192.5,279.5C 193.5,279.5 194.5,279.5 195.5,279.5C 195.5,276.833 195.5,274.167 195.5,271.5C 196.833,271.5 198.167,271.5 199.5,271.5C 199.5,267.5 199.5,263.5 199.5,259.5C 200.822,259.67 201.989,259.337 203,258.5C 204.764,251.643 207.597,245.309 211.5,239.5C 212.325,235.878 212.825,232.211 213,228.5C 215.583,224.913 217.75,221.08 219.5,217C 217.935,213.493 218.435,210.326 221,207.5C 222.685,209.988 224.019,209.655 225,206.5C 227.25,199.422 229.584,192.422 232,185.5C 233.011,186.337 234.178,186.67 235.5,186.5C 235.5,185.5 235.5,184.5 235.5,183.5C 234.448,183.649 233.448,183.483 232.5,183C 234.741,178.106 237.074,173.273 239.5,168.5C 250.085,167.182 250.085,166.515 239.5,166.5C 238.833,164.181 238.666,161.847 239,159.5C 240.14,162.939 241.973,163.106 244.5,160C 243.692,159.692 243.025,159.192 242.5,158.5C 243.5,156.5 244.5,154.5 245.5,152.5C 244.975,151.808 244.308,151.308 243.5,151C 243.833,150.667 244.167,150.333 244.5,150C 242.559,149.257 240.726,149.424 239,150.5C 238.722,149.584 238.222,148.918 237.5,148.5C 237.328,147.508 237.662,146.842 238.5,146.5C 252.088,145.519 265.754,145.185 279.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48484a",
    d: "M 279.5,145.5 C 284.167,145.5 288.833,145.5 293.5,145.5C 293.5,147.5 293.5,149.5 293.5,151.5C 293.5,151.833 293.5,152.167 293.5,152.5C 293.167,152.5 292.833,152.5 292.5,152.5C 291.5,152.5 290.5,152.5 289.5,152.5C 289.5,153.833 289.5,155.167 289.5,156.5C 286.355,157.077 284.855,159.077 285,162.5C 284.395,160.519 283.395,160.185 282,161.5C 281.82,163.488 281.986,165.488 282.5,167.5C 282.068,168.71 281.401,169.71 280.5,170.5C 278.413,170.061 276.246,169.728 274,169.5C 273.955,172.22 274.455,174.886 275.5,177.5C 275.672,178.492 275.338,179.158 274.5,179.5C 273.094,179.973 272.427,180.973 272.5,182.5C 270.192,186.795 267.526,190.795 264.5,194.5C 263.094,194.973 262.427,195.973 262.5,197.5C 261.525,199.795 260.192,201.795 258.5,203.5C 257.094,203.973 256.427,204.973 256.5,206.5C 249.315,218.216 241.649,229.549 233.5,240.5C 233.586,239.504 233.252,238.671 232.5,238C 233.167,237.667 233.833,237.333 234.5,237C 232.543,234.879 232.043,232.379 233,229.5C 234.079,227.606 235.413,227.273 237,228.5C 237.658,226.892 237.158,225.725 235.5,225C 238.42,224.592 240.754,223.259 242.5,221C 241.167,220 241.167,219 242.5,218C 240.619,216.898 238.952,215.565 237.5,214C 238.424,212.189 239.257,212.355 240,214.5C 241.333,212.167 243.333,211.167 246,211.5C 248.411,212.4 250.578,212.233 252.5,211C 251.348,208.851 249.848,207.018 248,205.5C 247.517,206.448 247.351,207.448 247.5,208.5C 245.801,208.66 244.134,208.494 242.5,208C 243.448,207.517 244.448,207.351 245.5,207.5C 245.561,204.27 247.228,202.437 250.5,202C 249.128,198.459 249.294,194.959 251,191.5C 251.29,193.044 251.956,194.377 253,195.5C 253.282,191.961 253.782,188.461 254.5,185C 253.032,182.972 253.199,181.138 255,179.5C 255.333,180.833 255.667,182.167 256,183.5C 256.692,177.9 258.192,172.566 260.5,167.5C 261.5,167.5 262.5,167.5 263.5,167.5C 264.093,164.404 263.093,162.071 260.5,160.5C 264.157,158.526 266.157,155.526 266.5,151.5C 267.873,151.657 269.207,151.49 270.5,151C 268.641,150.316 266.974,149.316 265.5,148C 268.13,147.155 270.464,147.655 272.5,149.5C 274.525,147.436 276.858,146.102 279.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#9b9b9a",
    d: "M 22.5,145.5 C 22.573,147.027 21.9063,148.027 20.5,148.5C 20.427,146.973 21.0937,145.973 22.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e1e1c",
    d: "M 79.5,148.5 C 79.8333,148.5 80.1667,148.5 80.5,148.5C 80.7376,150.404 81.7376,151.738 83.5,152.5C 83.427,154.027 84.0937,155.027 85.5,155.5C 85.427,157.027 86.0937,158.027 87.5,158.5C 87.7376,160.404 88.7376,161.738 90.5,162.5C 90.7329,164.062 91.3995,165.395 92.5,166.5C 91.4514,166.598 90.2847,166.598 89,166.5C 88.7083,168.326 88.875,170.159 89.5,172C 87.2744,177.399 86.6077,182.899 87.5,188.5C 84.9896,189.783 82.3229,190.783 79.5,191.5C 79.9288,197.07 79.2621,202.404 77.5,207.5C 76.1667,207.5 74.8333,207.5 73.5,207.5C 73.7886,213.591 73.4553,219.591 72.5,225.5C 72.5,226.833 72.5,228.167 72.5,229.5C 70.6612,228.248 68.8278,228.248 67,229.5C 67.3165,232.746 67.4832,236.08 67.5,239.5C 66.1667,239.5 64.8333,239.5 63.5,239.5C 63.5,242.5 63.5,245.5 63.5,248.5C 57.1481,249.379 57.1481,250.879 63.5,253C 61.0912,254.707 58.4245,255.54 55.5,255.5C 55.6646,258.518 55.498,261.518 55,264.5C 54.586,264.043 54.086,263.709 53.5,263.5C 52.3076,265.742 51.3076,268.075 50.5,270.5C 49.675,271.386 48.675,271.719 47.5,271.5C 47.5,276.833 47.5,282.167 47.5,287.5C 45.5,287.5 43.5,287.5 41.5,287.5C 40.5109,295.398 39.6775,303.398 39,311.5C 36.6667,314.167 34.3333,316.833 32,319.5C 31.5026,322.146 31.3359,324.813 31.5,327.5C 30.5,327.5 29.5,327.5 28.5,327.5C 27.8333,330.167 27.1667,332.833 26.5,335.5C 25.1266,335.657 23.7932,335.49 22.5,335C 23.3366,333.989 23.67,332.822 23.5,331.5C 21.549,331.227 20.049,331.893 19,333.5C 18.6667,333.167 18.3333,332.833 18,332.5C 17.5439,333.744 18.0439,334.577 19.5,335C 18.9341,335.995 18.2674,336.828 17.5,337.5C 17.3404,335.847 16.6737,334.514 15.5,333.5C 15.7373,332.209 15.404,331.209 14.5,330.5C 14.5979,328.447 13.9313,326.78 12.5,325.5C 12.5,325.167 12.5,324.833 12.5,324.5C 11.6124,319.928 10.2791,315.595 8.5,311.5C 8.4249,308.794 8.09157,306.127 7.5,303.5C 8.0264,299.431 9.19307,295.431 11,291.5C 11.6667,294.167 12.3333,294.167 13,291.5C 13.9868,284.509 15.4868,277.842 17.5,271.5C 18.8333,271.5 20.1667,271.5 21.5,271.5C 21.4065,266.225 22.2398,261.225 24,256.5C 25.2051,255.929 26.3717,255.262 27.5,254.5C 29.6506,251.264 30.8173,247.931 31,244.5C 31.3333,246.167 31.6667,247.833 32,249.5C 33.1662,248.166 33.3329,246.5 32.5,244.5C 33.1499,239.851 33.6499,235.184 34,230.5C 35.8003,227.949 37.8003,225.615 40,223.5C 41.2493,219.115 41.9159,214.781 42,210.5C 42.6667,211.167 43.3333,211.833 44,212.5C 46.8213,208.53 46.988,204.364 44.5,200C 46.1661,197.52 46.9994,194.687 47,191.5C 47.4974,194.146 47.6641,196.813 47.5,199.5C 48.5,199.5 49.5,199.5 50.5,199.5C 50.5,196.833 50.5,194.167 50.5,191.5C 51.5,191.5 52.5,191.5 53.5,191.5C 53.0268,185.455 55.0268,180.455 59.5,176.5C 58.5934,173.579 58.2601,170.579 58.5,167.5C 60.1667,167.5 61.8333,167.5 63.5,167.5C 63.5,165.167 63.5,162.833 63.5,160.5C 68.0407,160.669 68.374,160.002 64.5,158.5C 65.1153,155.961 65.7819,153.461 66.5,151C 66.1667,150.667 65.8333,150.333 65.5,150C 67.01,149.15 68.51,148.317 70,147.5C 70.9454,147.905 71.6121,148.572 72,149.5C 73.1369,148.636 74.4702,147.636 76,146.5C 77,147.5 78,148.5 79,149.5C 79.3988,149.272 79.5654,148.938 79.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.416
    },
    fill: "#b0b0af",
    d: "M 78.5,145.5 C 79.9063,145.973 80.573,146.973 80.5,148.5C 80.1667,148.5 79.8333,148.5 79.5,148.5C 78.8902,147.609 78.5569,146.609 78.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 81.5,147.5 C 82.8333,148.167 82.8333,148.167 81.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#41a3d6",
    d: "M 467.5,127.5 C 472.438,134.948 476.438,142.948 479.5,151.5C 478.5,151.5 477.5,151.5 476.5,151.5C 476.349,148.282 475.516,147.949 474,150.5C 473.308,149.975 472.808,149.308 472.5,148.5C 474.005,147.158 474.672,145.492 474.5,143.5C 473.5,143.5 472.5,143.5 471.5,143.5C 471.657,144.873 471.49,146.207 471,147.5C 469.282,145.798 469.115,143.965 470.5,142C 469.313,140.981 468.313,139.814 467.5,138.5C 468.84,137.312 469.507,135.812 469.5,134C 468.382,131.941 467.715,129.774 467.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#a4a4a4",
    d: "M 80.5,148.5 C 80.8333,148.5 81.1667,148.5 81.5,148.5C 82.6005,149.605 83.2671,150.938 83.5,152.5C 81.7376,151.738 80.7376,150.404 80.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    fill: "#a7a7a7",
    d: "M 237.5,148.5 C 237.262,150.404 236.262,151.738 234.5,152.5C 234.738,150.596 235.738,149.262 237.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 84.5,151.5 C 85.8333,152.167 85.8333,152.167 84.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 293.5,152.5 C 294.833,153.167 294.833,153.167 293.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.69
    },
    fill: "#b5b5b5",
    d: "M 234.5,152.5 C 234.573,154.027 233.906,155.027 232.5,155.5C 231.509,153.877 232.176,152.877 234.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.439
    },
    fill: "#afafaf",
    d: "M 83.5,152.5 C 83.8333,152.5 84.1667,152.5 84.5,152.5C 85.1098,153.391 85.4431,154.391 85.5,155.5C 84.0937,155.027 83.427,154.027 83.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#8c8c8c",
    d: "M 19.5,151.5 C 19.5848,154.649 18.5848,157.316 16.5,159.5C 16.7329,156.458 17.7329,153.792 19.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0398dc",
    d: "M 462.5,122.5 C 463.167,122.5 463.833,122.5 464.5,122.5C 466.25,123.659 467.25,125.326 467.5,127.5C 467.715,129.774 468.382,131.941 469.5,134C 469.507,135.812 468.84,137.312 467.5,138.5C 468.313,139.814 469.313,140.981 470.5,142C 469.115,143.965 469.282,145.798 471,147.5C 471.49,146.207 471.657,144.873 471.5,143.5C 472.5,143.5 473.5,143.5 474.5,143.5C 474.672,145.492 474.005,147.158 472.5,148.5C 472.808,149.308 473.308,149.975 474,150.5C 475.516,147.949 476.349,148.282 476.5,151.5C 477.5,151.5 478.5,151.5 479.5,151.5C 479.5,151.833 479.5,152.167 479.5,152.5C 480.568,157.828 480.735,163.162 480,168.5C 480.419,167.328 481.085,166.328 482,165.5C 481.747,168.133 481.747,170.8 482,173.5C 483.117,172.051 483.784,170.384 484,168.5C 484.153,171.866 483.986,175.033 483.5,178C 484.416,178.374 485.25,178.874 486,179.5C 486.5,181.5 487,183.5 487.5,185.5C 484.712,191.968 485.046,198.302 488.5,204.5C 489.167,203.167 489.833,201.833 490.5,200.5C 490.833,202.333 491.167,204.167 491.5,206C 490.875,209.438 490.875,212.771 491.5,216C 489.905,215.383 488.572,215.716 487.5,217C 488.167,217.333 488.833,217.667 489.5,218C 488.949,219.398 488.616,220.732 488.5,222C 489.536,223.617 490.703,223.784 492,222.5C 492.35,220.571 493.017,218.571 494,216.5C 495.035,226.889 495.868,237.222 496.5,247.5C 495.834,255.488 495.501,263.488 495.5,271.5C 494.965,279.512 494.299,287.512 493.5,295.5C 491.292,301.873 489.959,308.54 489.5,315.5C 486.875,320.328 485.542,325.662 485.5,331.5C 485.435,334.428 484.768,337.095 483.5,339.5C 482.18,341.463 480.846,343.463 479.5,345.5C 478.251,346.778 476.751,347.778 475,348.5C 474.316,349.784 474.483,350.951 475.5,352C 470.816,352.461 466.149,352.295 461.5,351.5C 461.831,281.929 461.498,212.429 460.5,143C 461.944,141.874 462.61,140.374 462.5,138.5C 461.621,135.188 461.454,131.855 462,128.5C 462.333,129.5 462.667,130.5 463,131.5C 464.02,130.109 464.853,128.609 465.5,127C 462.945,122.517 461.278,122.683 460.5,127.5C 459.015,126.179 457.682,124.679 456.5,123C 457.648,121.274 458.815,121.441 460,123.5C 460.342,121.381 461.175,121.047 462.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.541
    },
    fill: "#989898",
    d: "M 85.5,155.5 C 86.9063,155.973 87.573,156.973 87.5,158.5C 86.0937,158.027 85.427,157.027 85.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#a6a6a6",
    d: "M 232.5,155.5 C 232.573,157.027 231.906,158.027 230.5,158.5C 230.427,156.973 231.094,155.973 232.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 289.5,158.5 C 290.833,159.167 290.833,159.167 289.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.384
    },
    fill: "#9fdff3",
    d: "M 430.5,155.5 C 432.585,157.684 433.585,160.351 433.5,163.5C 431.98,161.11 430.98,158.443 430.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.663
    },
    fill: "#a2a2a0",
    d: "M 87.5,158.5 C 88.6828,159.504 90.0161,160.338 91.5,161C 90.944,161.383 90.6107,161.883 90.5,162.5C 88.7376,161.738 87.7376,160.404 87.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717173",
    d: "M 292.5,152.5 C 292.489,154.017 291.823,155.184 290.5,156C 290.833,156.333 291.167,156.667 291.5,157C 290.584,157.278 289.918,157.778 289.5,158.5C 287.292,160.125 286.459,162.125 287,164.5C 286.667,164.167 286.333,163.833 286,163.5C 285.051,165.093 283.885,166.426 282.5,167.5C 281.986,165.488 281.82,163.488 282,161.5C 283.395,160.185 284.395,160.519 285,162.5C 284.855,159.077 286.355,157.077 289.5,156.5C 289.5,155.167 289.5,153.833 289.5,152.5C 290.5,152.5 291.5,152.5 292.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 92.5,162.5 C 93.8333,163.167 93.8333,163.167 92.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.525
    },
    fill: "#a7a7a7",
    d: "M 90.5,162.5 C 91.1667,162.833 91.8333,163.167 92.5,163.5C 93.1098,164.391 93.4431,165.391 93.5,166.5C 93.1667,166.5 92.8333,166.5 92.5,166.5C 91.3995,165.395 90.7329,164.062 90.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.804
    },
    fill: "#898989",
    d: "M 15.5,163.5 C 15.7406,165.898 15.0739,167.898 13.5,169.5C 13.595,167.214 14.2616,165.214 15.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.729
    },
    fill: "#b4b4b4",
    d: "M 225.5,165.5 C 225.5,166.833 224.833,167.5 223.5,167.5C 223.062,167.565 222.728,167.399 222.5,167C 223.527,166.487 224.527,165.987 225.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    fill: "#afafaf",
    d: "M 93.5,166.5 C 94.9063,166.973 95.573,167.973 95.5,169.5C 94.0937,169.027 93.427,168.027 93.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 293.5,168.5 C 294.833,169.167 294.833,169.167 293.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#6a6869",
    d: "M 280.5,170.5 C 280.611,171.117 280.944,171.617 281.5,172C 279.356,172.792 278.023,174.292 277.5,176.5C 276.833,176.5 276.5,176.833 276.5,177.5C 276.167,177.5 275.833,177.5 275.5,177.5C 274.455,174.886 273.955,172.22 274,169.5C 276.246,169.728 278.413,170.061 280.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 282.5,169.5 C 283.833,170.167 283.833,170.167 282.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3d",
    d: "M 237.5,148.5 C 238.222,148.918 238.722,149.584 239,150.5C 240.726,149.424 242.559,149.257 244.5,150C 244.167,150.333 243.833,150.667 243.5,151C 244.308,151.308 244.975,151.808 245.5,152.5C 244.5,154.5 243.5,156.5 242.5,158.5C 243.025,159.192 243.692,159.692 244.5,160C 241.973,163.106 240.14,162.939 239,159.5C 238.666,161.847 238.833,164.181 239.5,166.5C 250.085,166.515 250.085,167.182 239.5,168.5C 237.074,173.273 234.741,178.106 232.5,183C 233.448,183.483 234.448,183.649 235.5,183.5C 235.5,184.5 235.5,185.5 235.5,186.5C 234.178,186.67 233.011,186.337 232,185.5C 229.584,192.422 227.25,199.422 225,206.5C 224.019,209.655 222.685,209.988 221,207.5C 218.435,210.326 217.935,213.493 219.5,217C 217.75,221.08 215.583,224.913 213,228.5C 212.825,232.211 212.325,235.878 211.5,239.5C 207.597,245.309 204.764,251.643 203,258.5C 201.989,259.337 200.822,259.67 199.5,259.5C 199.5,263.5 199.5,267.5 199.5,271.5C 198.167,271.5 196.833,271.5 195.5,271.5C 195.5,274.167 195.5,276.833 195.5,279.5C 194.5,279.5 193.5,279.5 192.5,279.5C 192.039,283.509 192.872,287.176 195,290.5C 196.204,289.529 196.704,288.529 196.5,287.5C 196.833,288.333 197.167,289.167 197.5,290C 195.194,293.159 192.361,296.659 189,300.5C 188.465,298.729 187.631,298.396 186.5,299.5C 188.022,301.156 187.689,302.323 185.5,303C 186.416,303.374 187.25,303.874 188,304.5C 188.399,304.272 188.565,303.938 188.5,303.5C 189.525,303.897 189.692,304.563 189,305.5C 184.717,307.453 182.383,310.786 182,315.5C 181.086,314.346 180.253,314.513 179.5,316C 180.451,316.718 180.617,317.551 180,318.5C 177.562,317.134 177.062,317.634 178.5,320C 177.115,321.597 176.449,323.43 176.5,325.5C 175.662,325.842 175.328,326.508 175.5,327.5C 174.189,330.135 172.522,332.469 170.5,334.5C 169.094,334.973 168.427,335.973 168.5,337.5C 168.5,337.833 168.5,338.167 168.5,338.5C 167.662,338.842 167.328,339.508 167.5,340.5C 166.272,341.306 165.272,342.306 164.5,343.5C 163.094,343.973 162.427,344.973 162.5,346.5C 162.5,346.833 162.5,347.167 162.5,347.5C 162.167,347.5 161.833,347.5 161.5,347.5C 160.833,347.833 160.167,348.167 159.5,348.5C 158.272,347.694 157.272,346.694 156.5,345.5C 156.5,345.167 156.5,344.833 156.5,344.5C 156.446,342.368 155.446,341.035 153.5,340.5C 153.167,339.833 152.833,339.167 152.5,338.5C 152.446,336.368 151.446,335.035 149.5,334.5C 149.446,332.368 148.446,331.035 146.5,330.5C 144.808,328.795 143.475,326.795 142.5,324.5C 142.672,323.508 142.338,322.842 141.5,322.5C 140.5,322.167 139.833,321.5 139.5,320.5C 140.75,320.423 141.583,319.756 142,318.5C 143.993,319.147 145.659,320.813 147,323.5C 149.114,322.047 150.448,320.047 151,317.5C 152.419,316.54 153.919,315.707 155.5,315C 153.998,314.417 152.665,313.584 151.5,312.5C 153.065,308.928 155.065,305.595 157.5,302.5C 156.025,299.755 156.691,297.588 159.5,296C 158.426,293.03 159.593,291.197 163,290.5C 162.343,285.59 164.176,282.09 168.5,280C 167.978,279.439 167.645,278.772 167.5,278C 168.62,276.263 169.62,274.429 170.5,272.5C 169.975,271.808 169.308,271.308 168.5,271C 171.438,265.917 174.105,260.75 176.5,255.5C 178.614,252.93 180.947,250.597 183.5,248.5C 181.922,247.702 180.256,247.202 178.5,247C 182.638,246.352 183.305,244.685 180.5,242C 181.167,241.333 181.833,240.667 182.5,240C 181.386,238.43 180.053,237.097 178.5,236C 179.999,235.162 180.332,234.329 179.5,233.5C 179.5,232.833 179.5,232.167 179.5,231.5C 179.328,230.508 179.662,229.842 180.5,229.5C 182.587,228.415 183.92,226.749 184.5,224.5C 185.906,224.027 186.573,223.027 186.5,221.5C 186.328,220.508 186.662,219.842 187.5,219.5C 189.587,218.415 190.92,216.749 191.5,214.5C 192.906,214.027 193.573,213.027 193.5,211.5C 193.328,210.508 193.662,209.842 194.5,209.5C 196.262,208.738 197.262,207.404 197.5,205.5C 199.262,204.738 200.262,203.404 200.5,201.5C 200.328,200.508 200.662,199.842 201.5,199.5C 203.587,198.415 204.92,196.749 205.5,194.5C 205.427,192.973 206.094,191.973 207.5,191.5C 208.906,191.027 209.573,190.027 209.5,188.5C 210.906,188.027 211.573,187.027 211.5,185.5C 212.906,185.027 213.573,184.027 213.5,182.5C 214.11,181.609 214.443,180.609 214.5,179.5C 214.833,179.5 215.167,179.5 215.5,179.5C 216.794,178.71 217.961,177.71 219,176.5C 219.718,177.451 220.551,177.617 221.5,177C 220.464,175.224 220.464,173.391 221.5,171.5C 221.733,169.938 222.4,168.605 223.5,167.5C 224.833,167.5 225.5,166.833 225.5,165.5C 226.786,162.883 228.453,160.55 230.5,158.5C 231.906,158.027 232.573,157.027 232.5,155.5C 233.906,155.027 234.573,154.027 234.5,152.5C 236.262,151.738 237.262,150.404 237.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222222",
    d: "M 92.5,166.5 C 92.8333,166.5 93.1667,166.5 93.5,166.5C 93.427,168.027 94.0937,169.027 95.5,169.5C 95.427,171.027 96.0937,172.027 97.5,172.5C 97.7376,174.404 98.7376,175.738 100.5,176.5C 100.427,178.027 101.094,179.027 102.5,179.5C 102.427,181.027 103.094,182.027 104.5,182.5C 104.738,184.404 105.738,185.738 107.5,186.5C 107.5,187.167 107.5,187.833 107.5,188.5C 106.986,189.625 106.653,190.791 106.5,192C 105.668,192.688 105.002,192.521 104.5,191.5C 103.922,187.383 102.755,187.717 101,192.5C 100.779,201.19 97.9461,208.857 92.5,215.5C 91.4512,218.08 90.7845,220.746 90.5,223.5C 89.5,223.5 88.5,223.5 87.5,223.5C 87.7517,228.69 87.085,233.357 85.5,237.5C 82.6848,236.771 80.6848,235.771 79.5,234.5C 79.4456,232.368 78.4456,231.035 76.5,230.5C 76.573,228.973 75.9063,227.973 74.5,227.5C 74.5,226.167 73.8333,225.5 72.5,225.5C 73.4553,219.591 73.7886,213.591 73.5,207.5C 74.8333,207.5 76.1667,207.5 77.5,207.5C 79.2621,202.404 79.9288,197.07 79.5,191.5C 82.3229,190.783 84.9896,189.783 87.5,188.5C 86.6077,182.899 87.2744,177.399 89.5,172C 88.875,170.159 88.7083,168.326 89,166.5C 90.2847,166.598 91.4514,166.598 92.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.529
    },
    fill: "#9c9c9c",
    d: "M 95.5,169.5 C 96.9063,169.973 97.573,170.973 97.5,172.5C 96.0937,172.027 95.427,171.027 95.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.635
    },
    fill: "#979797",
    d: "M 97.5,172.5 C 99.2624,173.262 100.262,174.596 100.5,176.5C 98.7376,175.738 97.7376,174.404 97.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.412
    },
    fill: "#b0dae9",
    d: "M 294.5,172.5 C 294.262,174.404 293.262,175.738 291.5,176.5C 291.738,174.596 292.738,173.262 294.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#bbeefc",
    d: "M 436.5,172.5 C 437.924,174.515 438.59,176.848 438.5,179.5C 437.076,177.485 436.41,175.152 436.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.824
    },
    fill: "#868684",
    d: "M 12.5,173.5 C 12.7406,175.898 12.0739,177.898 10.5,179.5C 10.595,177.214 11.2616,175.214 12.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757575",
    d: "M 221.5,171.5 C 220.464,173.391 220.464,175.224 221.5,177C 220.551,177.617 219.718,177.451 219,176.5C 217.961,177.71 216.794,178.71 215.5,179.5C 217.016,176.467 219.016,173.8 221.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 277.5,176.5 C 278.833,177.167 278.833,177.167 277.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 276.5,177.5 C 276.833,177.5 277.167,177.5 277.5,177.5C 277.315,178.17 276.981,178.17 276.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#a0a0a0",
    d: "M 100.5,176.5 C 101.906,176.973 102.573,177.973 102.5,179.5C 101.094,179.027 100.427,178.027 100.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 214.5,179.5 C 213.833,178.167 213.833,178.167 214.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.639
    },
    fill: "#8d8d8d",
    d: "M 102.5,179.5 C 103.906,179.973 104.573,180.973 104.5,182.5C 103.094,182.027 102.427,181.027 102.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 105.5,181.5 C 106.833,182.167 106.833,182.167 105.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 212.5,182.5 C 211.833,181.167 211.833,181.167 212.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.114
    },
    fill: "#cdd2d2",
    d: "M 274.5,179.5 C 274.573,181.027 273.906,182.027 272.5,182.5C 272.427,180.973 273.094,179.973 274.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.741
    },
    fill: "#878787",
    d: "M 104.5,182.5 C 104.833,182.5 105.167,182.5 105.5,182.5C 106.6,183.605 107.267,184.938 107.5,186.5C 105.738,185.738 104.738,184.404 104.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.376
    },
    fill: "#bbbbbb",
    d: "M 212.5,182.5 C 212.833,182.5 213.167,182.5 213.5,182.5C 213.573,184.027 212.906,185.027 211.5,185.5C 211.557,184.391 211.89,183.391 212.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.463
    },
    fill: "#b0b0b0",
    d: "M 211.5,185.5 C 211.573,187.027 210.906,188.027 209.5,188.5C 209.427,186.973 210.094,185.973 211.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0570b0",
    d: "M 346.5,313.5 C 340.269,314.127 333.935,314.961 327.5,316C 334.167,316.667 334.167,317.333 327.5,318C 326.874,318.75 326.374,319.584 326,320.5C 325.833,324.333 325.667,328.167 325.5,332C 325.539,336.26 326.206,340.26 327.5,344C 326.475,346.071 325.642,348.238 325,350.5C 324.25,351.126 323.416,351.626 322.5,352C 317.845,352.499 313.179,352.666 308.5,352.5C 303.833,352.5 299.167,352.5 294.5,352.5C 293.432,351.566 292.099,351.232 290.5,351.5C 290.49,338.411 290.323,325.411 290,312.5C 289.333,311.167 288.667,311.167 288,312.5C 287.833,312 287.667,311.5 287.5,311C 288.289,309.374 289.289,307.874 290.5,306.5C 287.147,305.619 286.647,303.953 289,301.5C 289.308,302.308 289.808,302.975 290.5,303.5C 290.833,297.333 291.167,291.167 291.5,285C 291.012,254.368 290.845,223.535 291,192.5C 289.307,191.816 287.807,190.816 286.5,189.5C 283.826,193.837 280.493,197.504 276.5,200.5C 277.11,198.566 278.11,196.899 279.5,195.5C 280.906,195.027 281.573,194.027 281.5,192.5C 282.906,192.027 283.573,191.027 283.5,189.5C 285.905,185.027 288.571,180.694 291.5,176.5C 293.262,175.738 294.262,174.404 294.5,172.5C 295.117,172.389 295.617,172.056 296,171.5C 296.5,218.832 296.667,266.165 296.5,313.5C 313.167,313.5 329.833,313.5 346.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#292929",
    d: "M 107.5,188.5 C 108.5,189.167 109.5,189.833 110.5,190.5C 110.427,192.027 111.094,193.027 112.5,193.5C 112.427,195.027 113.094,196.027 114.5,196.5C 114.738,198.404 115.738,199.738 117.5,200.5C 117.738,202.404 118.738,203.738 120.5,204.5C 120.738,206.404 121.738,207.738 123.5,208.5C 124.338,208.842 124.672,209.508 124.5,210.5C 124.738,212.404 125.738,213.738 127.5,214.5C 127.427,216.027 128.094,217.027 129.5,217.5C 129.738,219.404 130.738,220.738 132.5,221.5C 132.427,223.027 133.094,224.027 134.5,224.5C 134.5,225.167 134.5,225.833 134.5,226.5C 133.542,226.047 132.708,225.381 132,224.5C 132.979,226.279 132.646,227.945 131,229.5C 130.632,226.309 129.799,222.976 128.5,219.5C 125.797,217.311 123.63,215.311 122,213.5C 121.161,216.14 121.661,218.473 123.5,220.5C 122.923,222.55 121.59,223.55 119.5,223.5C 119.93,227.438 118.93,230.938 116.5,234C 116.484,236.305 117.484,237.972 119.5,239C 116.891,241.067 114.391,243.234 112,245.5C 111.51,246.793 111.343,248.127 111.5,249.5C 110.448,249.351 109.448,249.517 108.5,250C 110.64,250.973 112.307,252.473 113.5,254.5C 112.183,266.399 111.517,266.399 111.5,254.5C 108.724,254.089 108.057,254.922 109.5,257C 108.244,258.845 107.244,260.845 106.5,263C 108.136,265.561 107.469,267.061 104.5,267.5C 103.833,267.5 103.167,267.5 102.5,267.5C 102.573,265.973 101.906,264.973 100.5,264.5C 99.0937,264.027 98.427,263.027 98.5,261.5C 98.4456,259.368 97.4456,258.035 95.5,257.5C 95.4456,255.368 94.4456,254.035 92.5,253.5C 91.6618,253.158 91.3284,252.492 91.5,251.5C 91.4456,249.368 90.4456,248.035 88.5,247.5C 88.573,245.973 87.9063,244.973 86.5,244.5C 86.1231,242.742 85.4565,241.075 84.5,239.5C 84.8627,238.817 85.1961,238.15 85.5,237.5C 87.085,233.357 87.7517,228.69 87.5,223.5C 88.5,223.5 89.5,223.5 90.5,223.5C 90.7845,220.746 91.4512,218.08 92.5,215.5C 97.9461,208.857 100.779,201.19 101,192.5C 102.755,187.717 103.922,187.383 104.5,191.5C 105.002,192.521 105.668,192.688 106.5,192C 106.653,190.791 106.986,189.625 107.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.616
    },
    fill: "#999999",
    d: "M 107.5,186.5 C 109.262,187.262 110.262,188.596 110.5,190.5C 109.5,189.833 108.5,189.167 107.5,188.5C 107.5,187.833 107.5,187.167 107.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.612
    },
    fill: "#97d6ef",
    d: "M 438.5,180.5 C 439.117,180.611 439.617,180.944 440,181.5C 441.161,187.464 441.994,193.464 442.5,199.5C 440.859,193.353 439.526,187.02 438.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#a1a1a1",
    d: "M 209.5,188.5 C 209.573,190.027 208.906,191.027 207.5,191.5C 207.427,189.973 208.094,188.973 209.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.365
    },
    fill: "#97cfe2",
    d: "M 283.5,189.5 C 283.573,191.027 282.906,192.027 281.5,192.5C 281.427,190.973 282.094,189.973 283.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#006cac",
    d: "M 294.5,352.5 C 287.825,352.666 281.158,352.5 274.5,352C 275.416,351.626 276.25,351.126 277,350.5C 277.667,308.5 277.667,266.5 277,224.5C 275.779,223.226 274.946,221.726 274.5,220C 276.143,217.359 277.31,214.526 278,211.5C 278.333,211.167 278.667,210.833 279,210.5C 279.186,212.9 279.686,215.234 280.5,217.5C 282.442,213.728 284.942,210.394 288,207.5C 288.851,204.947 288.518,202.614 287,200.5C 286.084,203.524 284.584,206.191 282.5,208.5C 280.022,207.278 279.022,205.278 279.5,202.5C 278.5,202.5 277.5,202.5 276.5,202.5C 276.5,201.833 276.5,201.167 276.5,200.5C 280.493,197.504 283.826,193.837 286.5,189.5C 287.807,190.816 289.307,191.816 291,192.5C 290.845,223.535 291.012,254.368 291.5,285C 291.167,291.167 290.833,297.333 290.5,303.5C 289.808,302.975 289.308,302.308 289,301.5C 286.647,303.953 287.147,305.619 290.5,306.5C 289.289,307.874 288.289,309.374 287.5,311C 287.667,311.5 287.833,312 288,312.5C 288.667,311.167 289.333,311.167 290,312.5C 290.323,325.411 290.49,338.411 290.5,351.5C 292.099,351.232 293.432,351.566 294.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.518
    },
    fill: "#9e9e9e",
    d: "M 110.5,190.5 C 111.906,190.973 112.573,191.973 112.5,193.5C 111.094,193.027 110.427,192.027 110.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#63b7dc",
    d: "M 488.5,178.5 C 491.082,184.827 492.748,191.493 493.5,198.5C 492.069,198.119 491.236,197.119 491,195.5C 490.165,189.823 489.331,184.156 488.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.318
    },
    fill: "#a6d7ea",
    d: "M 281.5,192.5 C 281.573,194.027 280.906,195.027 279.5,195.5C 279.427,193.973 280.094,192.973 281.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.624
    },
    fill: "#8a8a8a",
    d: "M 112.5,193.5 C 113.906,193.973 114.573,194.973 114.5,196.5C 113.094,196.027 112.427,195.027 112.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d9d9d9",
    d: "M 264.5,194.5 C 264.573,196.027 263.906,197.027 262.5,197.5C 262.427,195.973 263.094,194.973 264.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.043
    },
    fill: "#c4c4c3",
    d: "M 7.5,191.5 C 7.70621,194.495 7.03954,197.162 5.5,199.5C 5.56513,196.572 6.2318,193.905 7.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.718
    },
    fill: "#878787",
    d: "M 114.5,196.5 C 116.262,197.262 117.262,198.596 117.5,200.5C 115.738,199.738 114.738,198.404 114.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    fill: "#bebebe",
    d: "M 205.5,194.5 C 204.92,196.749 203.587,198.415 201.5,199.5C 202.08,197.251 203.413,195.585 205.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 118.5,199.5 C 119.833,200.167 119.833,200.167 118.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a0a0a0",
    d: "M 117.5,200.5 C 117.833,200.5 118.167,200.5 118.5,200.5C 119.6,201.605 120.267,202.938 120.5,204.5C 118.738,203.738 117.738,202.404 117.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.412
    },
    fill: "#98c6db",
    d: "M 276.5,200.5 C 276.5,201.167 276.5,201.833 276.5,202.5C 275.833,202.833 275.167,203.167 274.5,203.5C 274.427,201.973 275.094,200.973 276.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58
    },
    fill: "#a5a5a5",
    d: "M 200.5,201.5 C 200.262,203.404 199.262,204.738 197.5,205.5C 197.738,203.596 198.738,202.262 200.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#ddddde",
    d: "M 258.5,203.5 C 258.573,205.027 257.906,206.027 256.5,206.5C 256.427,204.973 257.094,203.973 258.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#cecece",
    d: "M 120.5,204.5 C 122.532,205.048 123.532,206.381 123.5,208.5C 121.738,207.738 120.738,206.404 120.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#91d7ec",
    d: "M 493.5,198.5 C 495.322,205.251 496.322,212.251 496.5,219.5C 494.765,212.736 493.765,205.736 493.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#c8c8c8",
    d: "M 197.5,205.5 C 197.262,207.404 196.262,208.738 194.5,209.5C 194.389,208.883 194.056,208.383 193.5,208C 194.984,207.338 196.317,206.504 197.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.702
    },
    fill: "#8d8d8d",
    d: "M 124.5,210.5 C 126.262,211.262 127.262,212.596 127.5,214.5C 125.738,213.738 124.738,212.404 124.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2e2e",
    d: "M 134.5,226.5 C 135.5,227.167 136.5,227.833 137.5,228.5C 137.738,230.404 138.738,231.738 140.5,232.5C 140.427,234.027 141.094,235.027 142.5,235.5C 142.427,237.027 143.094,238.027 144.5,238.5C 144.738,240.404 145.738,241.738 147.5,242.5C 147.5,243.167 147.5,243.833 147.5,244.5C 145.219,246.428 142.553,247.428 139.5,247.5C 139.5,250.167 139.5,252.833 139.5,255.5C 138.167,255.5 136.833,255.5 135.5,255.5C 135.204,258.263 134.204,260.763 132.5,263C 133.448,263.483 134.448,263.649 135.5,263.5C 135.669,268.041 135.002,268.374 133.5,264.5C 133.167,265.333 132.833,266.167 132.5,267C 131.753,269.547 131.42,272.047 131.5,274.5C 126.822,277.48 124.655,281.814 125,287.5C 123.853,289.819 122.019,291.152 119.5,291.5C 119.446,289.368 118.446,288.035 116.5,287.5C 116.573,285.973 115.906,284.973 114.5,284.5C 114.573,282.973 113.906,281.973 112.5,281.5C 112.446,279.368 111.446,278.035 109.5,277.5C 109.446,275.368 108.446,274.035 106.5,273.5C 105.662,273.158 105.328,272.492 105.5,271.5C 105.167,270.167 104.833,268.833 104.5,267.5C 107.469,267.061 108.136,265.561 106.5,263C 107.244,260.845 108.244,258.845 109.5,257C 108.057,254.922 108.724,254.089 111.5,254.5C 111.517,266.399 112.183,266.399 113.5,254.5C 112.307,252.473 110.64,250.973 108.5,250C 109.448,249.517 110.448,249.351 111.5,249.5C 111.343,248.127 111.51,246.793 112,245.5C 114.391,243.234 116.891,241.067 119.5,239C 117.484,237.972 116.484,236.305 116.5,234C 118.93,230.938 119.93,227.438 119.5,223.5C 121.59,223.55 122.923,222.55 123.5,220.5C 121.661,218.473 121.161,216.14 122,213.5C 123.63,215.311 125.797,217.311 128.5,219.5C 129.799,222.976 130.632,226.309 131,229.5C 132.646,227.945 132.979,226.279 132,224.5C 132.708,225.381 133.542,226.047 134.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.553
    },
    fill: "#a0a0a0",
    d: "M 193.5,211.5 C 193.573,213.027 192.906,214.027 191.5,214.5C 191.427,212.973 192.094,211.973 193.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0267a8",
    d: "M 294.5,352.5 C 299.167,352.5 303.833,352.5 308.5,352.5C 308.5,352.833 308.5,353.167 308.5,353.5C 288.833,353.5 269.167,353.5 249.5,353.5C 249.333,316.498 249.5,279.498 250,242.5C 251.039,241.756 251.539,240.756 251.5,239.5C 251.75,237.326 252.75,235.659 254.5,234.5C 255.906,234.027 256.573,233.027 256.5,231.5C 258.229,230.883 259.729,229.883 261,228.5C 262.356,229.38 263.856,229.714 265.5,229.5C 265.297,227.362 264.297,225.695 262.5,224.5C 264.044,223.378 265.377,223.711 266.5,225.5C 266.226,221.881 266.559,218.215 267.5,214.5C 269.446,210.561 271.779,206.894 274.5,203.5C 275.167,203.167 275.833,202.833 276.5,202.5C 277.5,202.5 278.5,202.5 279.5,202.5C 279.022,205.278 280.022,207.278 282.5,208.5C 284.584,206.191 286.084,203.524 287,200.5C 288.518,202.614 288.851,204.947 288,207.5C 284.942,210.394 282.442,213.728 280.5,217.5C 279.686,215.234 279.186,212.9 279,210.5C 278.667,210.833 278.333,211.167 278,211.5C 277.31,214.526 276.143,217.359 274.5,220C 274.946,221.726 275.779,223.226 277,224.5C 277.667,266.5 277.667,308.5 277,350.5C 276.25,351.126 275.416,351.626 274.5,352C 281.158,352.5 287.825,352.666 294.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3fa3db",
    d: "M 479.5,152.5 C 483.669,160.671 486.669,169.338 488.5,178.5C 489.331,184.156 490.165,189.823 491,195.5C 491.236,197.119 492.069,198.119 493.5,198.5C 493.765,205.736 494.765,212.736 496.5,219.5C 496.183,223.702 496.517,227.702 497.5,231.5C 498.818,242.069 498.818,252.735 497.5,263.5C 496.833,266.167 496.167,268.833 495.5,271.5C 495.501,263.488 495.834,255.488 496.5,247.5C 495.868,237.222 495.035,226.889 494,216.5C 493.017,218.571 492.35,220.571 492,222.5C 490.703,223.784 489.536,223.617 488.5,222C 488.616,220.732 488.949,219.398 489.5,218C 488.833,217.667 488.167,217.333 487.5,217C 488.572,215.716 489.905,215.383 491.5,216C 490.875,212.771 490.875,209.438 491.5,206C 491.167,204.167 490.833,202.333 490.5,200.5C 489.833,201.833 489.167,203.167 488.5,204.5C 485.046,198.302 484.712,191.968 487.5,185.5C 487,183.5 486.5,181.5 486,179.5C 485.25,178.874 484.416,178.374 483.5,178C 483.986,175.033 484.153,171.866 484,168.5C 483.784,170.384 483.117,172.051 482,173.5C 481.747,170.8 481.747,168.133 482,165.5C 481.085,166.328 480.419,167.328 480,168.5C 480.735,163.162 480.568,157.828 479.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.569
    },
    fill: "#999999",
    d: "M 127.5,214.5 C 128.906,214.973 129.573,215.973 129.5,217.5C 128.094,217.027 127.427,216.027 127.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#8c8c8c",
    d: "M 129.5,217.5 C 131.262,218.262 132.262,219.596 132.5,221.5C 130.738,220.738 129.738,219.404 129.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.157
    },
    fill: "#c3c3c3",
    d: "M 191.5,214.5 C 190.92,216.749 189.587,218.415 187.5,219.5C 188.08,217.251 189.413,215.585 191.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 133.5,219.5 C 134.833,220.167 134.833,220.167 133.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 135.5,222.5 C 134.833,221.167 134.833,221.167 135.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b7bae",
    d: "M 267.5,214.5 C 266.559,218.215 266.226,221.881 266.5,225.5C 265.377,223.711 264.044,223.378 262.5,224.5C 264.297,225.695 265.297,227.362 265.5,229.5C 263.856,229.714 262.356,229.38 261,228.5C 259.729,229.883 258.229,230.883 256.5,231.5C 259.78,225.559 263.447,219.892 267.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 135.5,222.5 C 136.833,223.167 136.833,223.167 135.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.561
    },
    fill: "#989898",
    d: "M 132.5,221.5 C 133.167,221.833 133.833,222.167 134.5,222.5C 134.5,223.167 134.5,223.833 134.5,224.5C 133.094,224.027 132.427,223.027 132.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#9e9e9e",
    d: "M 186.5,221.5 C 186.573,223.027 185.906,224.027 184.5,224.5C 184.427,222.973 185.094,221.973 186.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 136.5,224.5 C 137.833,225.167 137.833,225.167 136.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.234
    },
    fill: "#9ce3fa",
    d: "M 442.5,201.5 C 443.969,208.443 444.636,215.609 444.5,223C 444.499,227.68 444.166,232.18 443.5,236.5C 443.527,224.82 443.194,213.154 442.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#919191",
    d: "M 134.5,224.5 C 135.167,224.833 135.833,225.167 136.5,225.5C 137.11,226.391 137.443,227.391 137.5,228.5C 136.5,227.833 135.5,227.167 134.5,226.5C 134.5,225.833 134.5,225.167 134.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.612
    },
    fill: "#b2b2b2",
    d: "M 184.5,224.5 C 183.92,226.749 182.587,228.415 180.5,229.5C 180.774,227.019 182.107,225.353 184.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#232323",
    d: "M 72.5,229.5 C 72.5,234.167 72.5,238.833 72.5,243.5C 72.6664,252.506 72.4998,261.506 72,270.5C 71.6667,269.167 71.3333,267.833 71,266.5C 69.8518,270.453 69.0184,274.453 68.5,278.5C 72.449,278.693 72.449,279.193 68.5,280C 65.6591,281.582 64.6591,283.749 65.5,286.5C 63.6397,289.437 62.3063,292.603 61.5,296C 63.3249,297.466 63.8249,299.299 63,301.5C 62.6532,299.82 61.6532,298.82 60,298.5C 58.3244,300.478 56.8244,302.645 55.5,305C 56.2865,307.099 56.6199,309.266 56.5,311.5C 55.5,311.5 54.5,311.5 53.5,311.5C 53.3441,314.841 52.0108,317.674 49.5,320C 51.288,323.406 50.4547,325.906 47,327.5C 44.3886,334.668 41.3886,341.668 38,348.5C 37.3162,349.784 37.4829,350.951 38.5,352C 37.2845,354.096 36.4512,353.929 36,351.5C 34.6081,354.278 34.1081,357.278 34.5,360.5C 32.0314,361.067 29.698,361.067 27.5,360.5C 24.9922,356.818 22.9922,352.818 21.5,348.5C 21.5979,346.447 20.9313,344.78 19.5,343.5C 18.6618,343.158 18.3284,342.492 18.5,341.5C 18.5674,340.041 18.2341,338.708 17.5,337.5C 18.2674,336.828 18.9341,335.995 19.5,335C 18.0439,334.577 17.5439,333.744 18,332.5C 18.3333,332.833 18.6667,333.167 19,333.5C 20.049,331.893 21.549,331.227 23.5,331.5C 23.67,332.822 23.3366,333.989 22.5,335C 23.7932,335.49 25.1266,335.657 26.5,335.5C 27.1667,332.833 27.8333,330.167 28.5,327.5C 29.5,327.5 30.5,327.5 31.5,327.5C 31.3359,324.813 31.5026,322.146 32,319.5C 34.3333,316.833 36.6667,314.167 39,311.5C 39.6775,303.398 40.5109,295.398 41.5,287.5C 43.5,287.5 45.5,287.5 47.5,287.5C 47.5,282.167 47.5,276.833 47.5,271.5C 48.675,271.719 49.675,271.386 50.5,270.5C 51.3076,268.075 52.3076,265.742 53.5,263.5C 54.086,263.709 54.586,264.043 55,264.5C 55.498,261.518 55.6646,258.518 55.5,255.5C 58.4245,255.54 61.0912,254.707 63.5,253C 57.1481,250.879 57.1481,249.379 63.5,248.5C 63.5,245.5 63.5,242.5 63.5,239.5C 64.8333,239.5 66.1667,239.5 67.5,239.5C 67.4832,236.08 67.3165,232.746 67,229.5C 68.8278,228.248 70.6612,228.248 72.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#ececec",
    d: "M 74.5,227.5 C 75.9063,227.973 76.573,228.973 76.5,230.5C 75.8826,230.389 75.3826,230.056 75,229.5C 74.7679,230.737 74.2679,231.737 73.5,232.5C 73.5,231.167 73.5,229.833 73.5,228.5C 74.1667,228.5 74.5,228.167 74.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.486
    },
    fill: "#9ee6fa",
    d: "M 496.5,219.5 C 497.198,222.897 497.865,226.397 498.5,230C 497.944,230.383 497.611,230.883 497.5,231.5C 496.517,227.702 496.183,223.702 496.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#999999",
    d: "M 76.5,231.5 C 76.5,231.167 76.5,230.833 76.5,230.5C 78.4456,231.035 79.4456,232.368 79.5,234.5C 78.2719,233.694 77.2719,232.694 76.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58
    },
    fill: "#a6a6a6",
    d: "M 137.5,228.5 C 139.262,229.262 140.262,230.596 140.5,232.5C 138.738,231.738 137.738,230.404 137.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 76.5,231.5 C 75.8333,232.167 75.8333,232.167 76.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#a4a4a4",
    d: "M 179.5,231.5 C 179.5,232.167 179.5,232.833 179.5,233.5C 178.833,233.833 178.167,234.167 177.5,234.5C 177.427,232.973 178.094,231.973 179.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.439
    },
    fill: "#9ac5d8",
    d: "M 256.5,231.5 C 256.573,233.027 255.906,234.027 254.5,234.5C 254.427,232.973 255.094,231.973 256.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.451
    },
    fill: "#adadad",
    d: "M 140.5,232.5 C 141.906,232.973 142.573,233.973 142.5,235.5C 141.094,235.027 140.427,234.027 140.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.078
    },
    fill: "#e2fdfe",
    d: "M 297.5,288.5 C 297.667,248.832 297.5,209.165 297,169.5C 296.617,170.056 296.117,170.389 295.5,170.5C 295.821,168.952 296.821,168.285 298.5,168.5C 298.832,208.67 298.499,248.67 297.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    fill: "#a1a1a1",
    d: "M 177.5,234.5 C 177.262,236.404 176.262,237.738 174.5,238.5C 174.738,236.596 175.738,235.262 177.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 179.5,233.5 C 180.332,234.329 179.999,235.162 178.5,236C 180.053,237.097 181.386,238.43 182.5,240C 181.833,240.667 181.167,241.333 180.5,242C 183.305,244.685 182.638,246.352 178.5,247C 180.256,247.202 181.922,247.702 183.5,248.5C 180.947,250.597 178.614,252.93 176.5,255.5C 174.105,260.75 171.438,265.917 168.5,271C 169.308,271.308 169.975,271.808 170.5,272.5C 169.62,274.429 168.62,276.263 167.5,278C 167.645,278.772 167.978,279.439 168.5,280C 164.176,282.09 162.343,285.59 163,290.5C 159.593,291.197 158.426,293.03 159.5,296C 156.691,297.588 156.025,299.755 157.5,302.5C 155.065,305.595 153.065,308.928 151.5,312.5C 152.665,313.584 153.998,314.417 155.5,315C 153.919,315.707 152.419,316.54 151,317.5C 150.448,320.047 149.114,322.047 147,323.5C 145.659,320.813 143.993,319.147 142,318.5C 141.583,319.756 140.75,320.423 139.5,320.5C 138.662,320.158 138.328,319.492 138.5,318.5C 138.446,316.368 137.446,315.035 135.5,314.5C 134.512,313.205 133.512,311.872 132.5,310.5C 132.672,309.508 132.338,308.842 131.5,308.5C 129.147,306.14 127.147,303.473 125.5,300.5C 125.573,298.973 124.906,297.973 123.5,297.5C 123.573,295.973 122.906,294.973 121.5,294.5C 120.599,293.71 119.932,292.71 119.5,291.5C 122.019,291.152 123.853,289.819 125,287.5C 124.655,281.814 126.822,277.48 131.5,274.5C 131.42,272.047 131.753,269.547 132.5,267C 132.833,266.167 133.167,265.333 133.5,264.5C 135.002,268.374 135.669,268.041 135.5,263.5C 134.448,263.649 133.448,263.483 132.5,263C 134.204,260.763 135.204,258.263 135.5,255.5C 136.833,255.5 138.167,255.5 139.5,255.5C 139.5,252.833 139.5,250.167 139.5,247.5C 142.553,247.428 145.219,246.428 147.5,244.5C 148.5,245.167 149.5,245.833 150.5,246.5C 150.427,248.027 151.094,249.027 152.5,249.5C 152.427,251.027 153.094,252.027 154.5,252.5C 154.738,254.404 155.738,255.738 157.5,256.5C 157.418,258.252 158.251,259.252 160,259.5C 161.03,259.164 161.53,258.497 161.5,257.5C 162.906,257.027 163.573,256.027 163.5,254.5C 164.906,254.027 165.573,253.027 165.5,251.5C 167.262,250.738 168.262,249.404 168.5,247.5C 169.906,247.027 170.573,246.027 170.5,244.5C 171.906,244.027 172.573,243.027 172.5,241.5C 173.906,241.027 174.573,240.027 174.5,238.5C 176.262,237.738 177.262,236.404 177.5,234.5C 178.167,234.167 178.833,233.833 179.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 79.5,234.5 C 80.6848,235.771 82.6848,236.771 85.5,237.5C 85.1961,238.15 84.8627,238.817 84.5,239.5C 85.4565,241.075 86.1231,242.742 86.5,244.5C 85.8333,244.167 85.1667,243.833 84.5,243.5C 83.0991,240.366 81.4325,237.366 79.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#9c9c9c",
    d: "M 142.5,235.5 C 143.906,235.973 144.573,236.973 144.5,238.5C 143.094,238.027 142.427,237.027 142.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 146.5,238.5 C 147.833,239.167 147.833,239.167 146.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.824
    },
    fill: "#7f7f7f",
    d: "M 72.5,225.5 C 73.8333,225.5 74.5,226.167 74.5,227.5C 73.8333,227.5 73.5,227.833 73.5,228.5C 73.5,229.833 73.5,231.167 73.5,232.5C 74.4895,256.425 74.8229,280.425 74.5,304.5C 73.8333,284.167 73.1667,263.833 72.5,243.5C 72.5,238.833 72.5,234.167 72.5,229.5C 72.5,228.167 72.5,226.833 72.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667
    },
    fill: "#989898",
    d: "M 144.5,238.5 C 145.167,238.833 145.833,239.167 146.5,239.5C 147.11,240.391 147.443,241.391 147.5,242.5C 145.738,241.738 144.738,240.404 144.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#afafaf",
    d: "M 174.5,238.5 C 174.573,240.027 173.906,241.027 172.5,241.5C 172.427,239.973 173.094,238.973 174.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 84.5,243.5 C 83.8333,244.167 83.8333,244.167 84.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 169.5,244.5 C 168.833,243.167 168.833,243.167 169.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.514
    },
    fill: "#a2a2a2",
    d: "M 172.5,241.5 C 172.573,243.027 171.906,244.027 170.5,244.5C 170.427,242.973 171.094,241.973 172.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#aaaaaa",
    d: "M 147.5,242.5 C 149.262,243.262 150.262,244.596 150.5,246.5C 149.5,245.833 148.5,245.167 147.5,244.5C 147.5,243.833 147.5,243.167 147.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d5d5d5",
    d: "M 86.5,244.5 C 87.9063,244.973 88.573,245.973 88.5,247.5C 87.0937,247.027 86.427,246.027 86.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.576
    },
    fill: "#979797",
    d: "M 169.5,244.5 C 169.833,244.5 170.167,244.5 170.5,244.5C 170.573,246.027 169.906,247.027 168.5,247.5C 168.557,246.391 168.89,245.391 169.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#909090",
    d: "M 88.5,247.5 C 90.4456,248.035 91.4456,249.368 91.5,251.5C 90.0256,250.564 89.0256,249.23 88.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#b2b2b2",
    d: "M 150.5,246.5 C 151.906,246.973 152.573,247.973 152.5,249.5C 151.094,249.027 150.427,248.027 150.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#959595",
    d: "M 168.5,247.5 C 168.262,249.404 167.262,250.738 165.5,251.5C 165.738,249.596 166.738,248.262 168.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.537
    },
    fill: "#a0a0a0",
    d: "M 152.5,249.5 C 153.906,249.973 154.573,250.973 154.5,252.5C 153.094,252.027 152.427,251.027 152.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#88888b",
    d: "M 226.5,251.5 C 225.974,253.23 224.974,254.564 223.5,255.5C 223.34,253.801 223.506,252.134 224,250.5C 224.671,251.252 225.504,251.586 226.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.478
    },
    fill: "#a7a7a7",
    d: "M 165.5,251.5 C 165.573,253.027 164.906,254.027 163.5,254.5C 163.427,252.973 164.094,251.973 165.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.647
    },
    fill: "#989898",
    d: "M 154.5,252.5 C 156.262,253.262 157.262,254.596 157.5,256.5C 155.738,255.738 154.738,254.404 154.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#b0b0b0",
    d: "M 92.5,253.5 C 94.4456,254.035 95.4456,255.368 95.5,257.5C 94.0256,256.564 93.0256,255.23 92.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 158.5,256.5 C 158.897,255.475 159.563,255.308 160.5,256C 159.906,256.464 159.239,256.631 158.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#9b9b9b",
    d: "M 163.5,254.5 C 163.573,256.027 162.906,257.027 161.5,257.5C 161.427,255.973 162.094,254.973 163.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#949494",
    d: "M 95.5,257.5 C 97.4456,258.035 98.4456,259.368 98.5,261.5C 97.0256,260.564 96.0256,259.23 95.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.078
    },
    fill: "#d8d8d8",
    d: "M 223.5,255.5 C 224.491,257.123 223.824,258.123 221.5,258.5C 221.427,256.973 222.094,255.973 223.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.498
    },
    fill: "#a5a5a5",
    d: "M 157.5,256.5 C 157.833,256.5 158.167,256.5 158.5,256.5C 159.105,258.481 160.105,258.815 161.5,257.5C 161.53,258.497 161.03,259.164 160,259.5C 158.251,259.252 157.418,258.252 157.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.613
    },
    fill: "#9ec8d9",
    d: "M 251.5,239.5 C 251.539,240.756 251.039,241.756 250,242.5C 249.5,279.498 249.333,316.498 249.5,353.5C 324.998,354.499 400.665,354.833 476.5,354.5C 400.668,355.666 324.668,355.832 248.5,355C 248.798,318.352 248.465,281.352 247.5,244C 248.328,242.008 249.661,240.508 251.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#dbdbdb",
    d: "M 100.5,264.5 C 101.906,264.973 102.573,265.973 102.5,267.5C 101.094,267.027 100.427,266.027 100.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#292929",
    d: "M 72.5,243.5 C 73.1667,263.833 73.8333,284.167 74.5,304.5C 74.4095,307.152 75.0762,309.485 76.5,311.5C 76.0535,314.01 76.7202,316.01 78.5,317.5C 78.0535,320.01 78.7202,322.01 80.5,323.5C 80.317,325.936 80.9837,328.103 82.5,330C 82.2716,330.399 81.9382,330.565 81.5,330.5C 79.9705,331.067 78.4705,331.733 77,332.5C 76,337.167 75,341.833 74,346.5C 72.6107,350.272 71.6107,350.272 71,346.5C 68.5111,348.473 68.3445,350.306 70.5,352C 68.6433,355.236 66.9766,358.569 65.5,362C 64.5547,364.089 64.5547,366.089 65.5,368C 62.9761,371.061 61.3095,374.561 60.5,378.5C 56.8475,380.283 56.5141,382.616 59.5,385.5C 58.6798,387.111 57.3464,387.778 55.5,387.5C 55.6495,388.552 55.4828,389.552 55,390.5C 53.8525,389.542 52.8525,389.875 52,391.5C 50.2775,386.405 49.1109,386.738 48.5,392.5C 47.8333,392.167 47.1667,391.833 46.5,391.5C 45.1638,389.693 43.4971,388.193 41.5,387C 41.8333,386.667 42.1667,386.333 42.5,386C 41.1772,385.184 40.5106,384.017 40.5,382.5C 40.2488,380.83 39.5822,379.33 38.5,378C 39.1667,377.667 39.8333,377.333 40.5,377C 38.5189,375.732 36.5189,374.566 34.5,373.5C 33.5,372.167 32.5,370.833 31.5,369.5C 29.8946,366.622 28.5612,363.622 27.5,360.5C 29.698,361.067 32.0314,361.067 34.5,360.5C 34.1081,357.278 34.6081,354.278 36,351.5C 36.4512,353.929 37.2845,354.096 38.5,352C 37.4829,350.951 37.3162,349.784 38,348.5C 41.3886,341.668 44.3886,334.668 47,327.5C 50.4547,325.906 51.288,323.406 49.5,320C 52.0108,317.674 53.3441,314.841 53.5,311.5C 54.5,311.5 55.5,311.5 56.5,311.5C 56.6199,309.266 56.2865,307.099 55.5,305C 56.8244,302.645 58.3244,300.478 60,298.5C 61.6532,298.82 62.6532,299.82 63,301.5C 63.8249,299.299 63.3249,297.466 61.5,296C 62.3063,292.603 63.6397,289.437 65.5,286.5C 64.6591,283.749 65.6591,281.582 68.5,280C 72.449,279.193 72.449,278.693 68.5,278.5C 69.0184,274.453 69.8518,270.453 71,266.5C 71.3333,267.833 71.6667,269.167 72,270.5C 72.4998,261.506 72.6664,252.506 72.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#979797",
    d: "M 102.5,267.5 C 103.167,267.5 103.833,267.5 104.5,267.5C 104.833,268.833 105.167,270.167 105.5,271.5C 104.026,270.564 103.026,269.23 102.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.514
    },
    fill: "#aee5f3",
    d: "M 440.5,261.5 C 440.58,264.781 439.913,267.781 438.5,270.5C 438.42,267.219 439.087,264.219 440.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 106.5,274.5 C 105.833,275.167 105.833,275.167 106.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#c6c6c6",
    d: "M 106.5,274.5 C 106.5,274.167 106.5,273.833 106.5,273.5C 108.446,274.035 109.446,275.368 109.5,277.5C 108.272,276.694 107.272,275.694 106.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.078
    },
    fill: "#dbdbdb",
    d: "M 211.5,273.5 C 212.491,275.123 211.824,276.123 209.5,276.5C 209.427,274.973 210.094,273.973 211.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a3e5f5",
    d: "M 497.5,263.5 C 497.299,274.445 495.965,285.112 493.5,295.5C 494.299,287.512 494.965,279.512 495.5,271.5C 496.167,268.833 496.833,266.167 497.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#999999",
    d: "M 109.5,277.5 C 111.446,278.035 112.446,279.368 112.5,281.5C 111.026,280.564 110.026,279.23 109.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    fill: "#a3e1f5",
    d: "M 437.5,275.5 C 437.435,278.428 436.768,281.095 435.5,283.5C 435.294,280.505 435.96,277.838 437.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d2d2d2",
    d: "M 112.5,281.5 C 113.906,281.973 114.573,282.973 114.5,284.5C 113.833,284.167 113.167,283.833 112.5,283.5C 112.5,282.833 112.5,282.167 112.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 112.5,283.5 C 111.833,284.167 111.833,284.167 112.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#e2e2e2",
    d: "M 114.5,284.5 C 115.906,284.973 116.573,285.973 116.5,287.5C 114.952,287.179 114.285,286.179 114.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.055
    },
    fill: "#c5c5c5",
    d: "M 2.5,279.5 C 3.64374,283.964 4.31041,288.63 4.5,293.5C 2.89581,289.1 2.22914,284.434 2.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#96d8ec",
    d: "M 435.5,283.5 C 435.472,286.916 434.472,289.916 432.5,292.5C 432.928,289.215 433.928,286.215 435.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#9b9b9b",
    d: "M 116.5,287.5 C 118.446,288.035 119.446,289.368 119.5,291.5C 118.026,290.564 117.026,289.23 116.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 201.5,289.5 C 202.833,290.167 202.833,290.167 201.5,289.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#dedede",
    d: "M 121.5,294.5 C 122.906,294.973 123.573,295.973 123.5,297.5C 122.094,297.027 121.427,296.027 121.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e6e6e6",
    d: "M 123.5,297.5 C 124.906,297.973 125.573,298.973 125.5,300.5C 124.094,300.027 123.427,299.027 123.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.659
    },
    fill: "#98d3e9",
    d: "M 432.5,293.5 C 432.23,297.358 430.897,300.691 428.5,303.5C 429.263,299.863 430.597,296.53 432.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#e8e8e8",
    d: "M 194.5,298.5 C 194.715,300.179 194.048,301.179 192.5,301.5C 192.932,300.29 193.599,299.29 194.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.612
    },
    fill: "#a1e1f3",
    d: "M 493.5,295.5 C 492.785,302.411 491.451,309.077 489.5,315.5C 489.959,308.54 491.292,301.873 493.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.196
    },
    fill: "#bcbcbc",
    d: "M 5.5,299.5 C 6.34464,300.671 7.01131,302.005 7.5,303.5C 8.09157,306.127 8.4249,308.794 8.5,311.5C 6.71911,307.8 5.71911,303.8 5.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 189.5,307.5 C 190.833,308.167 190.833,308.167 189.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.176
    },
    fill: "#b6edf8",
    d: "M 428.5,304.5 C 428.293,307.241 427.293,309.574 425.5,311.5C 425.707,308.759 426.707,306.426 428.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#e9e9e9",
    d: "M 131.5,308.5 C 132.338,308.842 132.672,309.508 132.5,310.5C 130.302,310.591 129.969,309.925 131.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 188.5,309.5 C 189.833,310.167 189.833,310.167 188.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.478
    },
    fill: "#b2b2b2",
    d: "M 74.5,304.5 C 75.9238,306.515 76.5905,308.848 76.5,311.5C 75.0762,309.485 74.4095,307.152 74.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 187.5,310.5 C 187.833,310.5 188.167,310.5 188.5,310.5C 188.315,311.17 187.981,311.17 187.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.805
    },
    fill: "#6aa6c6",
    d: "M 297.5,288.5 C 297.5,296.167 297.5,303.833 297.5,311.5C 340.236,312.397 382.902,312.397 425.5,311.5C 425.5,312.167 425.5,312.833 425.5,313.5C 399.167,313.5 372.833,313.5 346.5,313.5C 329.833,313.5 313.167,313.5 296.5,313.5C 296.667,266.165 296.5,218.832 296,171.5C 295.617,172.056 295.117,172.389 294.5,172.5C 294.328,171.508 294.662,170.842 295.5,170.5C 296.117,170.389 296.617,170.056 297,169.5C 297.5,209.165 297.667,248.832 297.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#c3c3c3",
    d: "M 8.5,311.5 C 10.2791,315.595 11.6124,319.928 12.5,324.5C 10.1022,320.597 8.76887,316.264 8.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#9c9c9c",
    d: "M 135.5,314.5 C 137.446,315.035 138.446,316.368 138.5,318.5C 137.026,317.564 136.026,316.23 135.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767678",
    d: "M 192.5,301.5 C 192.611,302.117 192.944,302.617 193.5,303C 191.356,303.792 190.023,305.292 189.5,307.5C 188.662,307.842 188.328,308.508 188.5,309.5C 187.833,309.5 187.5,309.833 187.5,310.5C 186.167,310.833 186.167,311.167 187.5,311.5C 185.378,313.05 183.711,315.05 182.5,317.5C 181.263,318.965 180.263,320.632 179.5,322.5C 178.167,322.833 178.167,323.167 179.5,323.5C 178.71,324.401 177.71,325.068 176.5,325.5C 176.449,323.43 177.115,321.597 178.5,320C 177.062,317.634 177.562,317.134 180,318.5C 180.617,317.551 180.451,316.718 179.5,316C 180.253,314.513 181.086,314.346 182,315.5C 182.383,310.786 184.717,307.453 189,305.5C 189.692,304.563 189.525,303.897 188.5,303.5C 189.671,302.655 191.005,301.989 192.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0082c6",
    d: "M 421.5,314.5 C 421.271,316.433 420.438,318.1 419,319.5C 415.882,316.258 412.049,314.925 407.5,315.5C 407.5,316.5 407.5,317.5 407.5,318.5C 400.833,318.833 400.833,319.167 407.5,319.5C 407.334,329.839 407.5,340.172 408,350.5C 409.622,351.099 411.122,351.766 412.5,352.5C 395.809,352.759 379.143,352.425 362.5,351.5C 362.5,341.167 362.5,330.833 362.5,320.5C 366.776,319.516 371.109,318.683 375.5,318C 371.442,317.66 367.442,316.993 363.5,316C 364.833,315.667 366.167,315.333 367.5,315C 385.497,314.5 403.497,314.333 421.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#8c8c8c",
    d: "M 76.5,311.5 C 77.4582,313.302 78.1249,315.302 78.5,317.5C 76.7202,316.01 76.0535,314.01 76.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 182.5,317.5 C 183.833,318.167 183.833,318.167 182.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#027aba",
    d: "M 346.5,313.5 C 372.833,313.5 399.167,313.5 425.5,313.5C 424.432,314.434 423.099,314.768 421.5,314.5C 403.497,314.333 385.497,314.5 367.5,315C 366.167,315.333 364.833,315.667 363.5,316C 367.442,316.993 371.442,317.66 375.5,318C 371.109,318.683 366.776,319.516 362.5,320.5C 362.5,330.833 362.5,341.167 362.5,351.5C 379.143,352.425 395.809,352.759 412.5,352.5C 416.371,352.185 420.038,352.518 423.5,353.5C 385.167,353.5 346.833,353.5 308.5,353.5C 308.5,353.167 308.5,352.833 308.5,352.5C 313.179,352.666 317.845,352.499 322.5,352C 323.416,351.626 324.25,351.126 325,350.5C 325.642,348.238 326.475,346.071 327.5,344C 326.206,340.26 325.539,336.26 325.5,332C 325.667,328.167 325.833,324.333 326,320.5C 326.374,319.584 326.874,318.75 327.5,318C 334.167,317.333 334.167,316.667 327.5,316C 333.935,314.961 340.269,314.127 346.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#8f8f8f",
    d: "M 78.5,317.5 C 79.7384,319.214 80.405,321.214 80.5,323.5C 78.7202,322.01 78.0535,320.01 78.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 179.5,322.5 C 180.833,323.167 180.833,323.167 179.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.063
    },
    fill: "#dddddd",
    d: "M 141.5,322.5 C 142.338,322.842 142.672,323.508 142.5,324.5C 140.302,324.591 139.969,323.925 141.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#f0f0f0",
    d: "M 176.5,325.5 C 178.011,327.838 177.677,328.504 175.5,327.5C 175.328,326.508 175.662,325.842 176.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.353
    },
    fill: "#b6b6b6",
    d: "M 12.5,325.5 C 13.9313,326.78 14.5979,328.447 14.5,330.5C 13.0687,329.22 12.4021,327.553 12.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 81.5,330.5 C 81.5,331.5 81.5,332.5 81.5,333.5C 82.9587,333.433 84.2921,333.766 85.5,334.5C 87.0075,336.181 88.0075,338.181 88.5,340.5C 88.427,342.027 89.0937,343.027 90.5,343.5C 91.1667,344.167 91.8333,344.833 92.5,345.5C 92.5569,346.609 92.8902,347.609 93.5,348.5C 93.3284,349.492 93.6618,350.158 94.5,350.5C 94.7376,352.404 95.7376,353.738 97.5,354.5C 97.427,356.027 98.0937,357.027 99.5,357.5C 100.08,359.749 101.413,361.415 103.5,362.5C 103.557,363.609 103.89,364.609 104.5,365.5C 102.343,366.127 100.343,365.46 98.5,363.5C 96.8742,361.221 96.0408,358.888 96,356.5C 91.5187,358.209 91.352,359.043 95.5,359C 94.5229,361.602 93.3563,364.102 92,366.5C 91.4444,364.405 90.9444,364.238 90.5,366C 90.7804,367.395 91.4471,368.562 92.5,369.5C 93.6086,368.41 94.6086,368.41 95.5,369.5C 92.598,371.183 89.7646,372.85 87,374.5C 86.1627,372.993 84.9961,372.493 83.5,373C 84.3281,374.992 85.6614,376.492 87.5,377.5C 88.5,378.833 89.5,380.167 90.5,381.5C 89.0597,382.363 87.7264,382.363 86.5,381.5C 86.1238,384.389 84.6238,386.389 82,387.5C 82.7634,390.42 82.0967,392.753 80,394.5C 79.502,397.482 79.3354,400.482 79.5,403.5C 78.1779,403.33 77.0113,403.663 76,404.5C 74.3741,407.998 73.2074,411.665 72.5,415.5C 69.9968,416.55 68.4968,415.55 68,412.5C 67.586,412.957 67.086,413.291 66.5,413.5C 65.3828,410.047 63.0495,408.047 59.5,407.5C 57.8333,406.5 56.5,405.167 55.5,403.5C 55.573,401.973 54.9063,400.973 53.5,400.5C 51.3674,398.909 49.7007,396.909 48.5,394.5C 48.5,393.833 48.5,393.167 48.5,392.5C 49.1109,386.738 50.2775,386.405 52,391.5C 52.8525,389.875 53.8525,389.542 55,390.5C 55.4828,389.552 55.6495,388.552 55.5,387.5C 57.3464,387.778 58.6798,387.111 59.5,385.5C 56.5141,382.616 56.8475,380.283 60.5,378.5C 61.3095,374.561 62.9761,371.061 65.5,368C 64.5547,366.089 64.5547,364.089 65.5,362C 66.9766,358.569 68.6433,355.236 70.5,352C 68.3445,350.306 68.5111,348.473 71,346.5C 71.6107,350.272 72.6107,350.272 74,346.5C 75,341.833 76,337.167 77,332.5C 78.4705,331.733 79.9705,331.067 81.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 80.5,323.5 C 82.3561,326.409 84.0227,329.409 85.5,332.5C 85.5,333.167 85.5,333.833 85.5,334.5C 84.2921,333.766 82.9587,333.433 81.5,333.5C 81.5,332.5 81.5,331.5 81.5,330.5C 81.9382,330.565 82.2716,330.399 82.5,330C 80.9837,328.103 80.317,325.936 80.5,323.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.145
    },
    fill: "#a2dcf1",
    d: "M 489.5,315.5 C 489.039,321.164 487.706,326.497 485.5,331.5C 485.542,325.662 486.875,320.328 489.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 85.5,331.5 C 86.8333,332.167 86.8333,332.167 85.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.086
    },
    fill: "#d3d3d3",
    d: "M 14.5,330.5 C 15.404,331.209 15.7373,332.209 15.5,333.5C 14.7611,333.631 14.0944,333.464 13.5,333C 14.2524,332.329 14.5858,331.496 14.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.498
    },
    fill: "#b7b7b7",
    d: "M 146.5,330.5 C 148.446,331.035 149.446,332.368 149.5,334.5C 149.167,334.5 148.833,334.5 148.5,334.5C 147.833,333.167 147.167,331.833 146.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 148.5,334.5 C 147.833,335.167 147.833,335.167 148.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#a0a0a0",
    d: "M 149.5,334.5 C 151.446,335.035 152.446,336.368 152.5,338.5C 151.026,337.564 150.026,336.23 149.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#d8d8d8",
    d: "M 170.5,334.5 C 170.573,336.027 169.906,337.027 168.5,337.5C 168.427,335.973 169.094,334.973 170.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 168.5,338.5 C 169.833,339.167 169.833,339.167 168.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.29
    },
    fill: "#bdbdbd",
    d: "M 15.5,333.5 C 16.6737,334.514 17.3404,335.847 17.5,337.5C 18.2341,338.708 18.5674,340.041 18.5,341.5C 16.7329,339.208 15.7329,336.542 15.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#fefffe",
    d: "M 167.5,340.5 C 168.833,341.167 168.833,341.167 167.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#dcdcdc",
    d: "M 88.5,340.5 C 90.8241,340.877 91.4908,341.877 90.5,343.5C 89.0937,343.027 88.427,342.027 88.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cbcbcb",
    d: "M 153.5,340.5 C 155.446,341.035 156.446,342.368 156.5,344.5C 156.167,344.5 155.833,344.5 155.5,344.5C 154.833,343.167 154.167,341.833 153.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 92.5,345.5 C 92.8966,344.475 93.5632,344.308 94.5,345C 93.9056,345.464 93.2389,345.631 92.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#fefffe",
    d: "M 155.5,344.5 C 155.5,345.167 155.833,345.5 156.5,345.5C 156.44,346.043 156.107,346.376 155.5,346.5C 154.227,345.743 154.227,345.077 155.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.075
    },
    fill: "#d6d6d6",
    d: "M 164.5,343.5 C 164.573,345.027 163.906,346.027 162.5,346.5C 162.427,344.973 163.094,343.973 164.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80c7e2",
    d: "M 483.5,339.5 C 482.935,343.537 481.601,347.203 479.5,350.5C 479.5,348.833 479.5,347.167 479.5,345.5C 480.846,343.463 482.18,341.463 483.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.298
    },
    fill: "#bbbbbb",
    d: "M 19.5,343.5 C 20.9313,344.78 21.5979,346.447 21.5,348.5C 20.0687,347.22 19.4021,345.553 19.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 162.5,347.5 C 163.833,348.167 163.833,348.167 162.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#dfdfdf",
    d: "M 93.5,348.5 C 95.6977,348.409 96.0311,349.075 94.5,350.5C 93.6618,350.158 93.3284,349.492 93.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.075
    },
    fill: "#dcdcdc",
    d: "M 161.5,347.5 C 161.5,348.167 161.833,348.5 162.5,348.5C 161.791,349.404 160.791,349.737 159.5,349.5C 159.5,349.167 159.5,348.833 159.5,348.5C 160.167,348.167 160.833,347.833 161.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 159.5,349.5 C 158.833,350.167 158.833,350.167 159.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51
    },
    fill: "#ababab",
    d: "M 94.5,350.5 C 96.2624,351.262 97.2624,352.596 97.5,354.5C 95.7376,353.738 94.7376,352.404 94.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.904
    },
    fill: "#4087af",
    d: "M 479.5,350.5 C 479.262,352.404 478.262,353.738 476.5,354.5C 400.665,354.833 324.998,354.499 249.5,353.5C 269.167,353.5 288.833,353.5 308.5,353.5C 346.833,353.5 385.167,353.5 423.5,353.5C 441.167,353.5 458.833,353.5 476.5,353.5C 476.121,350.433 477.121,349.433 479.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 246.5,355.5 C 247.833,356.167 247.833,356.167 246.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3a3a",
    d: "M 104.5,365.5 C 105.833,366.5 107.167,367.5 108.5,368.5C 108.833,368.5 109.167,368.5 109.5,368.5C 110.167,369.833 111.167,370.833 112.5,371.5C 113.833,373.5 115.5,375.167 117.5,376.5C 118.5,377.833 119.5,379.167 120.5,380.5C 121.262,382.262 122.596,383.262 124.5,383.5C 125.035,385.446 126.368,386.446 128.5,386.5C 129.539,388.531 131.205,389.864 133.5,390.5C 136.339,392.42 139.339,394.087 142.5,395.5C 142.5,395.833 142.5,396.167 142.5,396.5C 142.973,397.906 143.973,398.573 145.5,398.5C 146.492,398.328 147.158,398.662 147.5,399.5C 147.577,400.75 148.244,401.583 149.5,402C 147.668,402.748 146.001,403.748 144.5,405C 145.449,405.617 146.282,405.451 147,404.5C 148.852,406.23 148.686,407.396 146.5,408C 147.451,408.718 147.617,409.551 147,410.5C 143.642,406.724 139.809,406.724 135.5,410.5C 134.583,409.873 133.583,409.539 132.5,409.5C 131.833,409.5 131.167,409.5 130.5,409.5C 130.158,408.662 129.492,408.328 128.5,408.5C 128.5,408.167 128.5,407.833 128.5,407.5C 127.738,405.738 126.404,404.738 124.5,404.5C 122.326,404.25 120.659,403.25 119.5,401.5C 119.027,400.094 118.027,399.427 116.5,399.5C 116.027,398.094 115.027,397.427 113.5,397.5C 112.71,396.206 111.71,395.039 110.5,394C 111.167,393.667 111.833,393.333 112.5,393C 111.216,392.316 110.049,392.483 109,393.5C 108.184,392.177 107.017,391.511 105.5,391.5C 104.415,389.413 102.749,388.08 100.5,387.5C 99.4154,385.413 97.7488,384.08 95.5,383.5C 95.1667,383.5 94.8333,383.5 94.5,383.5C 94.5,382.833 94.1667,382.5 93.5,382.5C 93.5,382.167 93.5,381.833 93.5,381.5C 91.563,380.069 89.7297,378.402 88,376.5C 87.6012,376.728 87.4346,377.062 87.5,377.5C 85.6614,376.492 84.3281,374.992 83.5,373C 84.9961,372.493 86.1627,372.993 87,374.5C 89.7646,372.85 92.598,371.183 95.5,369.5C 94.6086,368.41 93.6086,368.41 92.5,369.5C 91.4471,368.562 90.7804,367.395 90.5,366C 90.9444,364.238 91.4444,364.405 92,366.5C 93.3563,364.102 94.5229,361.602 95.5,359C 91.352,359.043 91.5187,358.209 96,356.5C 96.0408,358.888 96.8742,361.221 98.5,363.5C 100.343,365.46 102.343,366.127 104.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.416
    },
    fill: "#b7b7b7",
    d: "M 97.5,354.5 C 98.9063,354.973 99.573,355.973 99.5,357.5C 98.0937,357.027 97.427,356.027 97.5,354.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.471
    },
    fill: "#b7b7b7",
    d: "M 99.5,357.5 C 101.587,358.585 102.92,360.251 103.5,362.5C 101.413,361.415 100.08,359.749 99.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.804
    },
    fill: "#b5b5b5",
    d: "M 103.5,362.5 C 105.525,364.196 107.525,365.863 109.5,367.5C 108.833,367.5 108.5,367.833 108.5,368.5C 107.167,367.5 105.833,366.5 104.5,365.5C 103.89,364.609 103.557,363.609 103.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 109.5,367.5 C 110.833,368.167 110.833,368.167 109.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 31.5,369.5 C 30.8333,370.167 30.8333,370.167 31.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 112.5,370.5 C 113.833,371.167 113.833,371.167 112.5,370.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 34.5,373.5 C 36.5189,374.566 38.5189,375.732 40.5,377C 39.8333,377.333 39.1667,377.667 38.5,378C 39.5822,379.33 40.2488,380.83 40.5,382.5C 37.7693,380.054 35.7693,377.054 34.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 117.5,375.5 C 118.833,376.167 118.833,376.167 117.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#c0c0c0",
    d: "M 93.5,381.5 C 92.8333,381.5 92.5,381.833 92.5,382.5C 91.8333,382.167 91.1667,381.833 90.5,381.5C 89.5,380.167 88.5,378.833 87.5,377.5C 87.4346,377.062 87.6012,376.728 88,376.5C 89.7297,378.402 91.563,380.069 93.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#c9c9c9",
    d: "M 120.5,380.5 C 122.062,380.733 123.395,381.4 124.5,382.5C 124.5,382.833 124.5,383.167 124.5,383.5C 122.596,383.262 121.262,382.262 120.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 90.5,381.5 C 91.1667,381.833 91.8333,382.167 92.5,382.5C 92.8333,382.5 93.1667,382.5 93.5,382.5C 94.1667,382.5 94.5,382.833 94.5,383.5C 94.5,384.167 94.8333,384.5 95.5,384.5C 95.5,384.833 95.5,385.167 95.5,385.5C 96.8333,388.833 99.1667,391.167 102.5,392.5C 104.833,394.167 106.833,396.167 108.5,398.5C 108.423,399.75 107.756,400.583 106.5,401C 107.833,401.333 109.167,401.667 110.5,402C 109.332,403.871 109.832,405.371 112,406.5C 112.626,408.713 112.459,410.88 111.5,413C 111.95,414.285 112.617,415.452 113.5,416.5C 112.111,419.238 110.111,421.405 107.5,423C 108.443,425.8 108.276,428.634 107,431.5C 104.586,434.815 102.919,438.482 102,442.5C 101.086,441.346 100.253,441.513 99.5,443C 100.756,443.417 101.423,444.25 101.5,445.5C 100.833,445.5 100.167,445.5 99.5,445.5C 98.4154,443.413 96.7488,442.08 94.5,441.5C 93.7377,439.738 92.4044,438.738 90.5,438.5C 89.5,438.167 88.8333,437.5 88.5,436.5C 86.4309,433.427 83.7642,431.094 80.5,429.5C 78.8333,428.5 77.5,427.167 76.5,425.5C 75.8333,424.167 74.8333,423.167 73.5,422.5C 71.9699,421.789 70.6366,420.789 69.5,419.5C 69.5,418.833 69.1667,418.5 68.5,418.5C 65.0985,415.105 62.0985,411.438 59.5,407.5C 63.0495,408.047 65.3828,410.047 66.5,413.5C 67.086,413.291 67.586,412.957 68,412.5C 68.4968,415.55 69.9968,416.55 72.5,415.5C 73.2074,411.665 74.3741,407.998 76,404.5C 77.0113,403.663 78.1779,403.33 79.5,403.5C 79.3354,400.482 79.502,397.482 80,394.5C 82.0967,392.753 82.7634,390.42 82,387.5C 84.6238,386.389 86.1238,384.389 86.5,381.5C 87.7264,382.363 89.0597,382.363 90.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 124.5,381.5 C 125.833,382.167 125.833,382.167 124.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#989898",
    d: "M 95.5,384.5 C 95.5,384.167 95.5,383.833 95.5,383.5C 97.7488,384.08 99.4154,385.413 100.5,387.5C 99.8333,387.5 99.1667,387.5 98.5,387.5C 98.5,386.833 98.1667,386.5 97.5,386.5C 97.5,385.833 97.1667,385.5 96.5,385.5C 96.5,384.833 96.1667,384.5 95.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 128.5,384.5 C 129.833,385.167 129.833,385.167 128.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.553
    },
    fill: "#ababab",
    d: "M 124.5,383.5 C 125.833,384.167 127.167,384.833 128.5,385.5C 128.5,385.833 128.5,386.167 128.5,386.5C 126.368,386.446 125.035,385.446 124.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#aaaaaa",
    d: "M 95.5,385.5 C 95.8333,385.5 96.1667,385.5 96.5,385.5C 97.1667,385.5 97.5,385.833 97.5,386.5C 98.1667,386.5 98.5,386.833 98.5,387.5C 99.8333,389.167 101.167,390.833 102.5,392.5C 99.1667,391.167 96.8333,388.833 95.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#939393",
    d: "M 100.5,387.5 C 102.749,388.08 104.415,389.413 105.5,391.5C 103.251,390.92 101.585,389.587 100.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#aaaaaa",
    d: "M 128.5,386.5 C 130.332,387.248 131.999,388.248 133.5,389.5C 133.5,389.833 133.5,390.167 133.5,390.5C 131.205,389.864 129.539,388.531 128.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 133.5,388.5 C 134.833,389.167 134.833,389.167 133.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#dddddd",
    d: "M 46.5,391.5 C 47.1667,391.833 47.8333,392.167 48.5,392.5C 48.5,393.167 48.5,393.833 48.5,394.5C 47.0937,394.027 46.427,393.027 46.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 105.5,391.5 C 107.017,391.511 108.184,392.177 109,393.5C 110.049,392.483 111.216,392.316 112.5,393C 111.833,393.333 111.167,393.667 110.5,394C 111.71,395.039 112.71,396.206 113.5,397.5C 110.467,395.984 107.8,393.984 105.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#fefffe",
    d: "M 360.5,393.5 C 361.167,392.167 361.833,392.167 362.5,393.5C 361.833,393.5 361.167,393.5 360.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.212
    },
    fill: "#eaeaea",
    d: "M 369.5,392.5 C 368.167,392.833 368.167,393.167 369.5,393.5C 366.591,396.106 363.591,397.773 360.5,398.5C 362.031,397.075 361.698,396.409 359.5,396.5C 360.694,395.728 361.694,394.728 362.5,393.5C 365.34,393.193 366.174,391.86 365,389.5C 365.928,391.335 367.094,391.668 368.5,390.5C 369.298,390.957 369.631,391.624 369.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 369.5,392.5 C 370.833,393.167 370.833,393.167 369.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 360.5,393.5 C 359.833,394.167 359.833,394.167 360.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 142.5,394.5 C 143.833,395.167 143.833,395.167 142.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.098
    },
    fill: "#d4d4d4",
    d: "M 142.5,396.5 C 144.027,396.427 145.027,397.094 145.5,398.5C 143.973,398.573 142.973,397.906 142.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.451
    },
    fill: "#b2b2b2",
    d: "M 113.5,397.5 C 115.027,397.427 116.027,398.094 116.5,399.5C 114.973,399.573 113.973,398.906 113.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 353.5,399.5 C 352.833,398.167 352.833,398.167 353.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#a4a4a4",
    d: "M 116.5,399.5 C 118.027,399.427 119.027,400.094 119.5,401.5C 118.833,401.5 118.167,401.5 117.5,401.5C 117.167,400.833 116.833,400.167 116.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#d3d3d3",
    d: "M 53.5,400.5 C 54.9063,400.973 55.573,401.973 55.5,403.5C 54.0937,403.027 53.427,402.027 53.5,400.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#fefffe",
    d: "M 117.5,401.5 C 117.5,402.833 116.833,403.5 115.5,403.5C 115.5,402.167 116.167,401.5 117.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#c3c3c3",
    d: "M 359.5,396.5 C 361.698,396.409 362.031,397.075 360.5,398.5C 354.806,402.68 348.806,406.346 342.5,409.5C 343.463,408.637 343.463,407.97 342.5,407.5C 341.583,408.127 340.583,408.461 339.5,408.5C 339.5,408.167 339.5,407.833 339.5,407.5C 342.317,406.905 344.65,405.572 346.5,403.5C 347.859,402.993 348.859,401.993 349.5,400.5C 351.031,401.421 352.365,401.088 353.5,399.5C 355.745,399.459 356.412,398.625 355.5,397C 356.959,397.355 358.293,397.189 359.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 346.5,403.5 C 345.833,402.167 345.833,402.167 346.5,403.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 439.5,404.5 C 436.999,404.489 436.832,403.822 439,402.5C 439.464,403.094 439.631,403.761 439.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4d50",
    d: "M 147.5,399.5 C 151.007,401.754 154.673,403.754 158.5,405.5C 162.182,408.008 166.182,410.008 170.5,411.5C 178.268,415.422 186.268,418.755 194.5,421.5C 196.102,423.074 198.102,423.741 200.5,423.5C 202.838,425.04 205.505,425.706 208.5,425.5C 208.833,425.5 209.167,425.5 209.5,425.5C 209.918,426.222 210.584,426.722 211.5,427C 219.147,428.386 226.814,429.553 234.5,430.5C 237.083,431.224 239.749,432.057 242.5,433C 239.332,433.582 238.999,434.582 241.5,436C 240.833,436.333 240.167,436.667 239.5,437C 231.648,437.181 223.981,437.348 216.5,437.5C 213.833,437.5 211.167,437.5 208.5,437.5C 208.167,437.5 207.833,437.5 207.5,437.5C 207.389,436.883 207.056,436.383 206.5,436C 203.518,435.502 200.518,435.335 197.5,435.5C 195.901,435.768 194.568,435.434 193.5,434.5C 188.806,432.386 183.806,431.053 178.5,430.5C 176.383,428.345 173.716,427.345 170.5,427.5C 168.214,427.405 166.214,426.738 164.5,425.5C 162.824,423.166 160.491,422.166 157.5,422.5C 155.716,422.107 154.05,421.441 152.5,420.5C 151.817,418.824 150.483,418.157 148.5,418.5C 146.847,418.34 145.514,417.674 144.5,416.5C 144.158,415.662 143.492,415.328 142.5,415.5C 140.287,414.227 137.954,413.227 135.5,412.5C 134.306,411.728 133.306,410.728 132.5,409.5C 133.583,409.539 134.583,409.873 135.5,410.5C 139.809,406.724 143.642,406.724 147,410.5C 147.617,409.551 147.451,408.718 146.5,408C 148.686,407.396 148.852,406.23 147,404.5C 146.282,405.451 145.449,405.617 144.5,405C 146.001,403.748 147.668,402.748 149.5,402C 148.244,401.583 147.577,400.75 147.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 158.5,404.5 C 159.833,405.167 159.833,405.167 158.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.007
    },
    fill: "#fefffe",
    d: "M 124.5,405.5 C 124.5,406.167 124.5,406.833 124.5,407.5C 122.067,406.452 122.067,405.786 124.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.588
    },
    fill: "#a0a0a0",
    d: "M 124.5,405.5 C 124.5,405.167 124.5,404.833 124.5,404.5C 126.404,404.738 127.738,405.738 128.5,407.5C 126.938,407.267 125.605,406.6 124.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e3e3f",
    d: "M 108.5,398.5 C 111.009,399.921 113.343,401.588 115.5,403.5C 120.317,407.74 125.317,411.74 130.5,415.5C 130.937,417.074 131.937,418.241 133.5,419C 131.355,419.743 131.189,420.576 133,421.5C 133.873,421.265 134.707,420.931 135.5,420.5C 137.323,421.747 139.323,422.414 141.5,422.5C 141.892,424.179 142.392,425.846 143,427.5C 143.333,426.833 143.667,426.167 144,425.5C 145,426.5 146,427.5 147,428.5C 147.671,427.748 148.504,427.414 149.5,427.5C 149.343,428.873 149.51,430.207 150,431.5C 151.616,430.199 153.116,430.199 154.5,431.5C 153.448,431.351 152.448,431.517 151.5,432C 152.343,434.117 152.677,436.45 152.5,439C 151.773,440.399 151.273,441.899 151,443.5C 148.298,444.72 147.464,446.554 148.5,449C 146.44,454.099 144.44,459.099 142.5,464C 142.833,464.333 143.167,464.667 143.5,465C 141.953,465.333 140.62,464.833 139.5,463.5C 137.142,465.287 134.475,466.287 131.5,466.5C 130.508,466.672 129.842,466.338 129.5,465.5C 129.158,464.662 128.492,464.328 127.5,464.5C 127.027,463.094 126.027,462.427 124.5,462.5C 123.508,462.672 122.842,462.338 122.5,461.5C 122.027,460.094 121.027,459.427 119.5,459.5C 119.027,458.094 118.027,457.427 116.5,457.5C 116.027,456.094 115.027,455.427 113.5,455.5C 113.027,454.094 112.027,453.427 110.5,453.5C 110.027,452.094 109.027,451.427 107.5,451.5C 106.738,449.738 105.404,448.738 103.5,448.5C 102.833,447.5 102.167,446.5 101.5,445.5C 101.423,444.25 100.756,443.417 99.5,443C 100.253,441.513 101.086,441.346 102,442.5C 102.919,438.482 104.586,434.815 107,431.5C 108.276,428.634 108.443,425.8 107.5,423C 110.111,421.405 112.111,419.238 113.5,416.5C 112.617,415.452 111.95,414.285 111.5,413C 112.459,410.88 112.626,408.713 112,406.5C 109.832,405.371 109.332,403.871 110.5,402C 109.167,401.667 107.833,401.333 106.5,401C 107.756,400.583 108.423,399.75 108.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 339.5,407.5 C 338.833,406.167 338.833,406.167 339.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#fefffe",
    d: "M 124.5,407.5 C 125.833,408.167 125.833,408.167 124.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 128.5,408.5 C 128.103,409.525 127.437,409.692 126.5,409C 127.094,408.536 127.761,408.369 128.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 335.5,409.5 C 334.833,408.167 334.833,408.167 335.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#a7a7a8",
    d: "M 435.5,413.5 C 435.178,411.278 435.845,409.444 437.5,408C 436.906,407.536 436.239,407.369 435.5,407.5C 436.833,406.5 438.167,405.5 439.5,404.5C 440.858,403.374 442.192,403.374 443.5,404.5C 441.52,408.137 438.854,411.137 435.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 130.5,409.5 C 130.5,409.833 130.5,410.167 130.5,410.5C 129.83,410.019 129.83,409.685 130.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 130.5,410.5 C 131.833,411.167 131.833,411.167 130.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 170.5,410.5 C 171.833,411.167 171.833,411.167 170.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 342.5,410.5 C 343.833,411.167 343.833,411.167 342.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 130.5,412.5 C 131.833,413.167 131.833,413.167 130.5,412.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 135.5,412.5 C 135.5,412.833 135.5,413.167 135.5,413.5C 134.83,413.019 134.83,412.685 135.5,412.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#fefffe",
    d: "M 135.5,413.5 C 136.833,414.167 136.833,414.167 135.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8e93",
    d: "M 435.5,407.5 C 436.239,407.369 436.906,407.536 437.5,408C 435.845,409.444 435.178,411.278 435.5,413.5C 431.108,418.894 426.108,423.561 420.5,427.5C 421.29,426.206 422.29,425.039 423.5,424C 423.043,423.586 422.709,423.086 422.5,422.5C 424.852,419.928 425.019,417.262 423,414.5C 421.644,415.38 420.144,415.714 418.5,415.5C 424.147,412.031 429.814,409.365 435.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 138.5,415.5 C 137.833,414.167 137.833,414.167 138.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 137.5,415.5 C 136.833,416.167 136.833,416.167 137.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#fefffe",
    d: "M 138.5,415.5 C 139.492,415.328 140.158,415.662 140.5,416.5C 139.508,416.672 138.842,416.338 138.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#f5f5f5",
    d: "M 142.5,415.5 C 143.492,415.328 144.158,415.662 144.5,416.5C 143.039,417.686 141.705,417.686 140.5,416.5C 141.492,416.672 142.158,416.338 142.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 333.5,415.5 C 334.833,416.167 334.833,416.167 333.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7c81",
    d: "M 420.5,427.5 C 411.733,437.556 401.733,446.223 390.5,453.5C 389.014,450.629 390.014,449.295 393.5,449.5C 394.662,446.32 396.662,443.653 399.5,441.5C 398.271,440.719 396.938,440.219 395.5,440C 397.955,439.606 399.955,438.44 401.5,436.5C 399.926,435.016 398.593,433.349 397.5,431.5C 399.833,430 402.167,428.5 404.5,427C 401.057,426.779 400.724,425.779 403.5,424C 401.08,424.025 398.747,424.691 396.5,426C 397.696,426.654 397.696,427.154 396.5,427.5C 395.817,427.137 395.15,426.804 394.5,426.5C 394.5,426.167 394.5,425.833 394.5,425.5C 402.343,421.991 410.343,418.658 418.5,415.5C 420.144,415.714 421.644,415.38 423,414.5C 425.019,417.262 424.852,419.928 422.5,422.5C 422.709,423.086 423.043,423.586 423.5,424C 422.29,425.039 421.29,426.206 420.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 134.5,416.5 C 135.833,417.167 135.833,417.167 134.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.007
    },
    fill: "#fefffe",
    d: "M 68.5,418.5 C 69.1667,418.5 69.5,418.833 69.5,419.5C 69.44,420.043 69.1067,420.376 68.5,420.5C 67.2267,419.743 67.2267,419.077 68.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 137.5,418.5 C 138.833,419.167 138.833,419.167 137.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 143.5,418.5 C 144.833,419.167 144.833,419.167 143.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#aaaaab",
    d: "M 148.5,418.5 C 150.483,418.157 151.817,418.824 152.5,420.5C 151.833,420.5 151.5,420.833 151.5,421.5C 150.778,421.082 150.278,420.416 150,419.5C 148.893,420.712 148.393,420.379 148.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#787878",
    d: "M 130.5,415.5 C 131.833,416.167 133.167,416.833 134.5,417.5C 135.29,418.401 136.29,419.068 137.5,419.5C 138.833,420.5 140.167,421.5 141.5,422.5C 139.323,422.414 137.323,421.747 135.5,420.5C 134.707,420.931 133.873,421.265 133,421.5C 131.189,420.576 131.355,419.743 133.5,419C 131.937,418.241 130.937,417.074 130.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 145.5,419.5 C 146.833,420.167 146.833,420.167 145.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8c8d",
    d: "M 342.5,409.5 C 342.5,409.833 342.5,410.167 342.5,410.5C 339.24,411.774 336.24,413.44 333.5,415.5C 324.166,420.335 314.499,424.335 304.5,427.5C 305.234,426.292 305.567,424.959 305.5,423.5C 302.167,423.833 298.833,424.167 295.5,424.5C 309.649,420.577 322.982,415.577 335.5,409.5C 336.833,409.167 338.167,408.833 339.5,408.5C 340.583,408.461 341.583,408.127 342.5,407.5C 343.463,407.97 343.463,408.637 342.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 301.5,420.5 C 302.833,421.167 302.833,421.167 301.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 69.5,421.5 C 70.8333,422.167 70.8333,422.167 69.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 151.5,421.5 C 152.167,421.5 152.5,421.833 152.5,422.5C 152.167,422.167 151.833,421.833 151.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.149
    },
    fill: "#d8d8d9",
    d: "M 200.5,423.5 C 198.102,423.741 196.102,423.074 194.5,421.5C 195.496,421.586 196.329,421.252 197,420.5C 197.985,421.814 199.152,422.814 200.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 152.5,422.5 C 153.833,423.167 153.833,423.167 152.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#9c9c9d",
    d: "M 157.5,422.5 C 160.491,422.166 162.824,423.166 164.5,425.5C 161.843,425.065 159.509,424.065 157.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 71.5,423.5 C 72.8333,424.167 72.8333,424.167 71.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cccccc",
    d: "M 73.5,422.5 C 74.8333,423.167 75.8333,424.167 76.5,425.5C 74.5,425.5 73.5,424.5 73.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.141
    },
    fill: "#d4d4d7",
    d: "M 200.5,423.5 C 203.428,423.565 206.095,424.232 208.5,425.5C 205.505,425.706 202.838,425.04 200.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.643
    },
    fill: "#cececf",
    d: "M 209.5,425.5 C 227.318,429 245.318,430.334 263.5,429.5C 254.014,430.494 244.348,430.827 234.5,430.5C 226.814,429.553 219.147,428.386 211.5,427C 210.584,426.722 209.918,426.222 209.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717173",
    d: "M 141.5,422.5 C 144.54,423.68 147.206,425.347 149.5,427.5C 148.504,427.414 147.671,427.748 147,428.5C 146,427.5 145,426.5 144,425.5C 143.667,426.167 143.333,426.833 143,427.5C 142.392,425.846 141.892,424.179 141.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.867
    },
    fill: "#9b9b9c",
    d: "M 170.5,427.5 C 173.716,427.345 176.383,428.345 178.5,430.5C 175.557,430.02 172.89,429.02 170.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#fefffe",
    d: "M 155.5,428.5 C 156.833,429.167 156.833,429.167 155.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.776
    },
    fill: "#b2b2b4",
    d: "M 281.5,427.5 C 277.119,429.211 272.453,429.877 267.5,429.5C 271.943,428.199 276.609,427.532 281.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#9e9e9e",
    d: "M 80.5,430.5 C 80.5,430.167 80.5,429.833 80.5,429.5C 83.7642,431.094 86.4309,433.427 88.5,436.5C 85.5691,434.909 82.9024,432.909 80.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707075",
    d: "M 390.5,453.5 C 376.613,463.615 361.613,471.949 345.5,478.5C 346.999,475.993 346.332,474.826 343.5,475C 344.888,475.889 344.722,476.389 343,476.5C 339.974,475.462 339.807,474.128 342.5,472.5C 343.451,473.326 344.451,473.492 345.5,473C 346.33,470.198 347.163,467.365 348,464.5C 349.011,463.663 350.178,463.33 351.5,463.5C 351.5,460.833 351.5,458.167 351.5,455.5C 352.5,455.5 353.5,455.5 354.5,455.5C 354.357,453.738 354.691,452.071 355.5,450.5C 356.651,449.269 357.817,449.269 359,450.5C 359.667,449.167 359.667,447.833 359,446.5C 357.844,447.993 357.01,447.826 356.5,446C 357.769,443.916 358.769,441.749 359.5,439.5C 362.602,439.846 365.435,439.179 368,437.5C 368.414,437.957 368.914,438.291 369.5,438.5C 369.677,435.922 370.843,435.922 373,438.5C 372.645,437.041 372.811,435.707 373.5,434.5C 380.43,431.854 387.43,429.187 394.5,426.5C 395.15,426.804 395.817,427.137 396.5,427.5C 397.696,427.154 397.696,426.654 396.5,426C 398.747,424.691 401.08,424.025 403.5,424C 400.724,425.779 401.057,426.779 404.5,427C 402.167,428.5 399.833,430 397.5,431.5C 398.593,433.349 399.926,435.016 401.5,436.5C 399.955,438.44 397.955,439.606 395.5,440C 396.938,440.219 398.271,440.719 399.5,441.5C 396.662,443.653 394.662,446.32 393.5,449.5C 390.014,449.295 389.014,450.629 390.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 80.5,430.5 C 79.8333,431.167 79.8333,431.167 80.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#ddddde",
    d: "M 301.5,428.5 C 298.916,430.472 295.916,431.472 292.5,431.5C 295.215,429.928 298.215,428.928 301.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#b7b6b9",
    d: "M 394.5,425.5 C 394.5,425.833 394.5,426.167 394.5,426.5C 387.43,429.187 380.43,431.854 373.5,434.5C 368.833,435.5 364.167,436.5 359.5,437.5C 370.995,433.266 382.661,429.266 394.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#676769",
    d: "M 149.5,427.5 C 151.5,428.167 153.5,428.833 155.5,429.5C 160.746,432.359 166.079,435.025 171.5,437.5C 169.409,437.318 167.409,437.652 165.5,438.5C 165.598,437.384 165.098,436.384 164,435.5C 162.739,435.759 161.739,436.426 161,437.5C 157.903,436.711 157.736,435.544 160.5,434C 158.331,433.571 156.331,434.071 154.5,435.5C 154.622,434.136 154.622,432.803 154.5,431.5C 153.116,430.199 151.616,430.199 150,431.5C 149.51,430.207 149.343,428.873 149.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#626165",
    d: "M 304.5,427.5 C 303.791,428.404 302.791,428.737 301.5,428.5C 298.215,428.928 295.215,429.928 292.5,431.5C 289.848,431.41 287.515,432.076 285.5,433.5C 283.095,434.768 280.428,435.435 277.5,435.5C 273.878,435.322 270.544,435.989 267.5,437.5C 267.167,437.5 266.833,437.5 266.5,437.5C 260.949,437.527 255.616,438.194 250.5,439.5C 242.371,440.784 234.371,440.784 226.5,439.5C 223.275,438.763 219.941,438.097 216.5,437.5C 223.981,437.348 231.648,437.181 239.5,437C 240.167,436.667 240.833,436.333 241.5,436C 238.999,434.582 239.332,433.582 242.5,433C 239.749,432.057 237.083,431.224 234.5,430.5C 244.348,430.827 254.014,430.494 263.5,429.5C 264.833,429.5 266.167,429.5 267.5,429.5C 272.453,429.877 277.119,429.211 281.5,427.5C 285.985,426.216 290.651,425.216 295.5,424.5C 298.833,424.167 302.167,423.833 305.5,423.5C 305.567,424.959 305.234,426.292 304.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#b7b7b8",
    d: "M 178.5,430.5 C 183.806,431.053 188.806,432.386 193.5,434.5C 188.194,433.947 183.194,432.614 178.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.063
    },
    fill: "#d2d2d5",
    d: "M 292.5,431.5 C 290.485,432.924 288.152,433.59 285.5,433.5C 287.515,432.076 289.848,431.41 292.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 167.5,433.5 C 168.833,434.167 168.833,434.167 167.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#949496",
    d: "M 197.5,435.5 C 200.518,435.335 203.518,435.502 206.5,436C 207.056,436.383 207.389,436.883 207.5,437.5C 203.922,437.451 200.589,436.785 197.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.106
    },
    fill: "#d4d4d7",
    d: "M 277.5,435.5 C 274.411,436.785 271.078,437.451 267.5,437.5C 270.544,435.989 273.878,435.322 277.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 355.5,437.5 C 354.833,436.167 354.833,436.167 355.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#fefffe",
    d: "M 177.5,437.5 C 178.833,438.167 178.833,438.167 177.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.698
    },
    fill: "#ababab",
    d: "M 90.5,439.5 C 90.5,439.167 90.5,438.833 90.5,438.5C 92.4044,438.738 93.7377,439.738 94.5,441.5C 92.9382,441.267 91.6049,440.6 90.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.357
    },
    fill: "#c4c4c5",
    d: "M 171.5,437.5 C 173.553,437.402 175.22,438.069 176.5,439.5C 174.447,439.598 172.78,438.931 171.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#b5b5b7",
    d: "M 208.5,437.5 C 211.167,437.5 213.833,437.5 216.5,437.5C 219.941,438.097 223.275,438.763 226.5,439.5C 220.274,439.612 214.274,438.946 208.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d2d2d2",
    d: "M 266.5,437.5 C 261.402,438.957 256.069,439.624 250.5,439.5C 255.616,438.194 260.949,437.527 266.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.616
    },
    fill: "#bbbbbc",
    d: "M 355.5,437.5 C 356.833,437.5 358.167,437.5 359.5,437.5C 356.495,439.277 353.162,440.277 349.5,440.5C 351.5,439.5 353.5,438.5 355.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 90.5,439.5 C 89.8333,440.167 89.8333,440.167 90.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fefffe",
    d: "M 260.5,439.5 C 261.833,440.167 261.833,440.167 260.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a696e",
    d: "M 373.5,434.5 C 372.811,435.707 372.645,437.041 373,438.5C 370.843,435.922 369.677,435.922 369.5,438.5C 368.914,438.291 368.414,437.957 368,437.5C 365.435,439.179 362.602,439.846 359.5,439.5C 358.769,441.749 357.769,443.916 356.5,446C 357.01,447.826 357.844,447.993 359,446.5C 359.667,447.833 359.667,449.167 359,450.5C 357.817,449.269 356.651,449.269 355.5,450.5C 354.691,452.071 354.357,453.738 354.5,455.5C 353.5,455.5 352.5,455.5 351.5,455.5C 351.5,458.167 351.5,460.833 351.5,463.5C 350.178,463.33 349.011,463.663 348,464.5C 347.163,467.365 346.33,470.198 345.5,473C 344.451,473.492 343.451,473.326 342.5,472.5C 339.807,474.128 339.974,475.462 343,476.5C 344.722,476.389 344.888,475.889 343.5,475C 346.332,474.826 346.999,475.993 345.5,478.5C 345.158,479.338 344.492,479.672 343.5,479.5C 341.447,479.402 339.78,480.069 338.5,481.5C 337.791,482.404 336.791,482.737 335.5,482.5C 329.885,482.718 324.885,484.384 320.5,487.5C 318.401,488.612 316.067,489.279 313.5,489.5C 314.728,487.99 314.728,486.49 313.5,485C 315.412,483.8 316.745,482.133 317.5,480C 315.193,479.646 314.859,478.646 316.5,477C 317.009,475.831 317.842,474.998 319,474.5C 320.011,475.337 321.178,475.67 322.5,475.5C 323.093,472.404 322.093,470.071 319.5,468.5C 320.628,467.738 321.795,467.071 323,466.5C 323.762,461.802 325.929,457.968 329.5,455C 328.663,453.989 328.33,452.822 328.5,451.5C 326.692,451.509 325.025,451.009 323.5,450C 325.379,449.04 327.379,448.54 329.5,448.5C 330.609,446.786 329.942,446.119 327.5,446.5C 327.5,446.167 327.5,445.833 327.5,445.5C 330.544,443.989 333.878,443.322 337.5,443.5C 340.152,443.59 342.485,442.924 344.5,441.5C 345.919,440.549 347.585,440.216 349.5,440.5C 353.162,440.277 356.495,439.277 359.5,437.5C 364.167,436.5 368.833,435.5 373.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#9a9a9a",
    d: "M 94.5,441.5 C 96.7488,442.08 98.4154,443.413 99.5,445.5C 97.2512,444.92 95.5846,443.587 94.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M 176.5,439.5 C 178.786,439.595 180.786,440.262 182.5,441.5C 181.178,441.33 180.011,441.663 179,442.5C 178.302,441.309 177.469,440.309 176.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#fefffe",
    d: "M 189.5,441.5 C 190.833,442.167 190.833,442.167 189.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464549",
    d: "M 154.5,431.5 C 154.622,432.803 154.622,434.136 154.5,435.5C 156.331,434.071 158.331,433.571 160.5,434C 157.736,435.544 157.903,436.711 161,437.5C 161.739,436.426 162.739,435.759 164,435.5C 165.098,436.384 165.598,437.384 165.5,438.5C 167.409,437.652 169.409,437.318 171.5,437.5C 172.78,438.931 174.447,439.598 176.5,439.5C 177.469,440.309 178.302,441.309 179,442.5C 180.011,441.663 181.178,441.33 182.5,441.5C 184.786,441.595 186.786,442.262 188.5,443.5C 188.5,444.167 188.833,444.5 189.5,444.5C 187.824,448.208 186.157,451.875 184.5,455.5C 187.167,455.5 189.833,455.5 192.5,455.5C 192.587,458.598 192.087,458.932 191,456.5C 188.806,459.554 187.139,462.888 186,466.5C 184.374,463.002 183.207,459.335 182.5,455.5C 182,462.028 180.666,468.361 178.5,474.5C 177.675,470.878 177.175,467.211 177,463.5C 174.613,468.621 174.113,473.954 175.5,479.5C 173.508,479.672 171.842,479.005 170.5,477.5C 169.833,478.167 169.167,478.833 168.5,479.5C 164.645,479.651 160.645,479.317 156.5,478.5C 154.824,476.166 152.491,475.166 149.5,475.5C 149.196,474.85 148.863,474.183 148.5,473.5C 145.122,472.41 141.789,471.41 138.5,470.5C 135.996,469.416 133.663,468.083 131.5,466.5C 134.475,466.287 137.142,465.287 139.5,463.5C 140.62,464.833 141.953,465.333 143.5,465C 143.167,464.667 142.833,464.333 142.5,464C 144.44,459.099 146.44,454.099 148.5,449C 147.464,446.554 148.298,444.72 151,443.5C 151.273,441.899 151.773,440.399 152.5,439C 152.677,436.45 152.343,434.117 151.5,432C 152.448,431.517 153.448,431.351 154.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.655
    },
    fill: "#c7c7c8",
    d: "M 344.5,441.5 C 342.485,442.924 340.152,443.59 337.5,443.5C 338.263,442.732 339.263,442.232 340.5,442C 339.304,441.346 339.304,440.846 340.5,440.5C 341.736,441.246 343.07,441.579 344.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.043
    },
    fill: "#c9c9ca",
    d: "M 188.5,443.5 C 191.428,443.565 194.095,444.232 196.5,445.5C 194.097,445.552 191.764,445.219 189.5,444.5C 188.833,444.5 188.5,444.167 188.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#9f9f9f",
    d: "M 99.5,445.5 C 100.167,445.5 100.833,445.5 101.5,445.5C 102.167,446.5 102.833,447.5 103.5,448.5C 101.596,448.262 100.262,447.262 99.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#bfbfc0",
    d: "M 201.5,446.5 C 208.048,447.392 214.381,448.725 220.5,450.5C 214.773,450.153 209.106,449.319 203.5,448C 202.584,447.722 201.918,447.222 201.5,446.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9d",
    d: "M 327.5,445.5 C 327.5,445.833 327.5,446.167 327.5,446.5C 324.371,446.819 321.538,447.819 319,449.5C 316.619,448.565 314.119,448.232 311.5,448.5C 316.63,447.087 321.963,446.087 327.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#a8a8a8",
    d: "M 103.5,448.5 C 105.404,448.738 106.738,449.738 107.5,451.5C 105.596,451.262 104.262,450.262 103.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.116
    },
    fill: "#e1e1e1",
    d: "M 229.5,451.5 C 227.833,451.5 226.167,451.5 224.5,451.5C 223.209,451.737 222.209,451.404 221.5,450.5C 221.435,450.062 221.601,449.728 222,449.5C 224.607,450.123 227.107,450.79 229.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4e52",
    d: "M 189.5,444.5 C 191.764,445.219 194.097,445.552 196.5,445.5C 198.216,445.629 199.883,445.962 201.5,446.5C 201.918,447.222 202.584,447.722 203.5,448C 209.106,449.319 214.773,450.153 220.5,450.5C 220.833,450.5 221.167,450.5 221.5,450.5C 222.209,451.404 223.209,451.737 224.5,451.5C 223.391,452.29 222.058,452.79 220.5,453C 221.624,453.249 222.624,453.749 223.5,454.5C 219.361,456.771 218.027,460.104 219.5,464.5C 218.608,467.639 216.775,469.972 214,471.5C 212.659,474.022 211.826,476.689 211.5,479.5C 212.552,479.351 213.552,479.517 214.5,480C 212.139,482.888 210.139,486.055 208.5,489.5C 207.571,488.45 206.905,488.45 206.5,489.5C 202.881,490.244 199.215,490.577 195.5,490.5C 193.162,488.96 190.495,488.294 187.5,488.5C 185.901,488.768 184.568,488.434 183.5,487.5C 178.5,485.057 173.166,483.39 167.5,482.5C 163.463,481.935 159.797,480.601 156.5,478.5C 160.645,479.317 164.645,479.651 168.5,479.5C 169.167,478.833 169.833,478.167 170.5,477.5C 171.842,479.005 173.508,479.672 175.5,479.5C 174.113,473.954 174.613,468.621 177,463.5C 177.175,467.211 177.675,470.878 178.5,474.5C 180.666,468.361 182,462.028 182.5,455.5C 183.207,459.335 184.374,463.002 186,466.5C 187.139,462.888 188.806,459.554 191,456.5C 192.087,458.932 192.587,458.598 192.5,455.5C 189.833,455.5 187.167,455.5 184.5,455.5C 186.157,451.875 187.824,448.208 189.5,444.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.427
    },
    fill: "#b0b0b0",
    d: "M 107.5,451.5 C 109.027,451.427 110.027,452.094 110.5,453.5C 108.973,453.573 107.973,452.906 107.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.205
    },
    fill: "#c1c1c2",
    d: "M 311.5,448.5 C 301.442,450.885 291.108,452.385 280.5,453C 268.838,453.5 257.171,453.667 245.5,453.5C 239.949,453.473 234.616,452.806 229.5,451.5C 256.946,453.416 284.279,452.416 311.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616064",
    d: "M 327.5,446.5 C 329.942,446.119 330.609,446.786 329.5,448.5C 327.379,448.54 325.379,449.04 323.5,450C 325.025,451.009 326.692,451.509 328.5,451.5C 328.33,452.822 328.663,453.989 329.5,455C 325.929,457.968 323.762,461.802 323,466.5C 321.795,467.071 320.628,467.738 319.5,468.5C 322.093,470.071 323.093,472.404 322.5,475.5C 321.178,475.67 320.011,475.337 319,474.5C 317.842,474.998 317.009,475.831 316.5,477C 314.859,478.646 315.193,479.646 317.5,480C 316.745,482.133 315.412,483.8 313.5,485C 314.728,486.49 314.728,487.99 313.5,489.5C 310.505,489.294 307.838,489.96 305.5,491.5C 303.958,492.301 302.292,492.634 300.5,492.5C 295.924,492.438 291.591,493.105 287.5,494.5C 281.863,495.697 276.196,496.697 270.5,497.5C 259.5,497.5 248.5,497.5 237.5,497.5C 233.833,496.833 230.167,496.167 226.5,495.5C 235.839,495.666 245.173,495.5 254.5,495C 253.351,493.256 252.017,493.089 250.5,494.5C 249.713,493.758 249.047,492.925 248.5,492C 250.721,490.331 251.055,488.331 249.5,486C 249.667,485.5 249.833,485 250,484.5C 250.833,485.5 251.667,486.5 252.5,487.5C 254.108,482.208 255.774,477.041 257.5,472C 256.346,471.086 256.513,470.253 258,469.5C 258.71,470.973 259.876,471.64 261.5,471.5C 261.604,466.915 260.604,462.582 258.5,458.5C 257.167,457.833 255.833,457.167 254.5,456.5C 254.709,455.914 255.043,455.414 255.5,455C 251.975,454.821 248.641,454.321 245.5,453.5C 257.171,453.667 268.838,453.5 280.5,453C 291.108,452.385 301.442,450.885 311.5,448.5C 314.119,448.232 316.619,448.565 319,449.5C 321.538,447.819 324.371,446.819 327.5,446.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.463
    },
    fill: "#a9a9aa",
    d: "M 110.5,453.5 C 112.027,453.427 113.027,454.094 113.5,455.5C 111.973,455.573 110.973,454.906 110.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555459",
    d: "M 224.5,451.5 C 226.167,451.5 227.833,451.5 229.5,451.5C 234.616,452.806 239.949,453.473 245.5,453.5C 248.641,454.321 251.975,454.821 255.5,455C 255.043,455.414 254.709,455.914 254.5,456.5C 255.833,457.167 257.167,457.833 258.5,458.5C 260.604,462.582 261.604,466.915 261.5,471.5C 259.876,471.64 258.71,470.973 258,469.5C 256.513,470.253 256.346,471.086 257.5,472C 255.774,477.041 254.108,482.208 252.5,487.5C 251.667,486.5 250.833,485.5 250,484.5C 249.833,485 249.667,485.5 249.5,486C 251.055,488.331 250.721,490.331 248.5,492C 249.047,492.925 249.713,493.758 250.5,494.5C 252.017,493.089 253.351,493.256 254.5,495C 245.173,495.5 235.839,495.666 226.5,495.5C 219.28,494.125 211.947,492.625 204.5,491C 205.416,490.722 206.082,490.222 206.5,489.5C 206.905,488.45 207.571,488.45 208.5,489.5C 210.139,486.055 212.139,482.888 214.5,480C 213.552,479.517 212.552,479.351 211.5,479.5C 211.826,476.689 212.659,474.022 214,471.5C 216.775,469.972 218.608,467.639 219.5,464.5C 218.027,460.104 219.361,456.771 223.5,454.5C 222.624,453.749 221.624,453.249 220.5,453C 222.058,452.79 223.391,452.29 224.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#acacae",
    d: "M 113.5,455.5 C 115.027,455.427 116.027,456.094 116.5,457.5C 114.973,457.573 113.973,456.906 113.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#fefffe",
    d: "M 116.5,458.5 C 115.833,459.167 115.833,459.167 116.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#bababa",
    d: "M 116.5,458.5 C 116.5,458.167 116.5,457.833 116.5,457.5C 118.027,457.427 119.027,458.094 119.5,459.5C 118.391,459.443 117.391,459.11 116.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.243
    },
    fill: "#cacaca",
    d: "M 119.5,459.5 C 121.027,459.427 122.027,460.094 122.5,461.5C 120.973,461.573 119.973,460.906 119.5,459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22
    },
    fill: "#d1d1d1",
    d: "M 124.5,462.5 C 126.027,462.427 127.027,463.094 127.5,464.5C 125.973,464.573 124.973,463.906 124.5,462.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.018
    },
    fill: "#ececed",
    d: "M 127.5,464.5 C 128.492,464.328 129.158,464.662 129.5,465.5C 128.075,467.031 127.409,466.698 127.5,464.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858586",
    d: "M 138.5,470.5 C 141.789,471.41 145.122,472.41 148.5,473.5C 148.863,474.183 149.196,474.85 149.5,475.5C 145.468,474.39 141.802,472.723 138.5,470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#9d9d9f",
    d: "M 149.5,475.5 C 152.491,475.166 154.824,476.166 156.5,478.5C 153.843,478.065 151.509,477.065 149.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.118
    },
    fill: "#e0e0e1",
    d: "M 343.5,479.5 C 342.22,480.931 340.553,481.598 338.5,481.5C 339.78,480.069 341.447,479.402 343.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.851
    },
    fill: "#acacad",
    d: "M 167.5,482.5 C 173.166,483.39 178.5,485.057 183.5,487.5C 177.834,486.61 172.5,484.943 167.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acacae",
    d: "M 335.5,482.5 C 330.778,484.741 325.778,486.407 320.5,487.5C 324.885,484.384 329.885,482.718 335.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.561
    },
    fill: "#b4b4b8",
    d: "M 187.5,488.5 C 190.495,488.294 193.162,488.96 195.5,490.5C 192.505,490.706 189.838,490.04 187.5,488.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929294",
    d: "M 206.5,489.5 C 206.082,490.222 205.416,490.722 204.5,491C 211.947,492.625 219.28,494.125 226.5,495.5C 215.818,495.211 205.485,493.544 195.5,490.5C 199.215,490.577 202.881,490.244 206.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#e3e3e3",
    d: "M 313.5,489.5 C 311.095,490.768 308.428,491.435 305.5,491.5C 307.838,489.96 310.505,489.294 313.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#dbdbdc",
    d: "M 300.5,492.5 C 296.433,494.054 292.1,494.72 287.5,494.5C 291.591,493.105 295.924,492.438 300.5,492.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdLogo);
export default __webpack_public_path__ + "static/media/MD_logo.97c129250a20af5699d0d9b98645e94a.svg";
export { ForwardRef as ReactComponent };